/**
 * A function to create a log object for the 'bookingsMemberMobileAppClassPageClicks' event (evid: 1021)
 *
 * Event description: when uou went to a class page on the member app and pressed the buttons. this is a generic event for all the clicks inside this page and this page modals.
 * the previous events were-
 * 16:574 - when  member clicked om 3 dots
 * 16:576 - when member clicked on remove in 3 dots modal
 * 16:572 - when member clicked on apply when edit a coupon.
 * the rest were missing.
 *
 * @param {bookingsMemberMobileAppClassPageClicksParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} logged_in_uuid - -
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {DateTime} datetime - -
 * @property {GUID} bookingId - -
 * @property {string} modalSelection - the selection in the modal, relevant for the modals that are opened in this page
 * @property {GUID} visitor_id - visitor_id
 * @property {string} element - the area of the page that the uou choose
 * @property {boolean} enterCouponFocus - true if the user started to fill the coupon name
 * @property {boolean} isAlreadyBooked - true if the session is already booked
 * @property {string} sessionId - -
 * @property {GUID} contactId - -
 * @property {number} time - -
 * @property {string} type - class/ appointment / course
 * @property {string} modalName - relevant for the modals that are opened in this page
 * @return {LogObject<bookingsMemberMobileAppClassPageClicksParams>} LogObject<bookingsMemberMobileAppClassPageClicksParams>
 */
export function bookingsMemberMobileAppClassPageClicks(params) {
    return { evid: 1021, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsMemberMobileAppBookingSummaryPageBookPayClick' event (evid: 1028)
 *
 * Event description: when members book a session and are on the booking summary page and click "Book & pay" or other continue buttion
 *
 * @param {bookingsMemberMobileAppBookingSummaryPageBookPayClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - class\course\appointment
 * @property {number} numNotRequiredFileds - how many of the fields are  not required?
 * @property {GUID} biToken - -
 * @property {number} numCheckbox - how many of the fields are  checkbox type?
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {number} numAllFields - how many fields there are in this form? (checkbox, paragraph...)
 * @property {string} answers - please give me the fields name and the answers
 * @property {string} continueButtonType - choose payment/ join to waitlist /book
 * @property {number} numRequiredFileds - how many of the fields are required?
 * @property {number} numShortAnswers - how many of the fields are  short type?
 * @property {GUID} contactId - contact_id
 * @property {number} numParaAnswers - how many of the fields are  paraghraph type?
 * @property {string} formType - default \ custom
 * @property {number} numFullFields - number of filled that filled by the member
 * @property {string} logged_session_uuid - -
 * @return {LogObject<bookingsMemberMobileAppBookingSummaryPageBookPayClickParams>} LogObject<bookingsMemberMobileAppBookingSummaryPageBookPayClickParams>
 */
export function bookingsMemberMobileAppBookingSummaryPageBookPayClick(params) {
    return { evid: 1028, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouBookingsSummaryChooseNumberOfParticipants' event (evid: 1051)
 *
 * Event description: when the uou chooses a number of participants on the bookings summary page.
 *
 * @param {bookingsUouBookingsSummaryChooseNumberOfParticipantsParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {GUID} visitor_id - -
 * @property {string} sessionId - -
 * @property {GUID} contactId - -
 * @property {string} serviceId - -
 * @return {LogObject<bookingsUouBookingsSummaryChooseNumberOfParticipantsParams>} LogObject<bookingsUouBookingsSummaryChooseNumberOfParticipantsParams>
 */
export function bookingsUouBookingsSummaryChooseNumberOfParticipants(params) {
    return { evid: 1051, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouBookingsFormClicks' event (evid: 1052)
 *
 * Event description: when uou makes interaction with the form
 *
 * @param {bookingsUouBookingsFormClicksParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {GUID} visitor_id - -
 * @property {GUID} contactId - -
 * @property {string} serviceId - service id
 * @property {string} value - which payment was sent
 * @property {string} action - what was clicked
 * @property {string} formId - --
 * @return {LogObject<bookingsUouBookingsFormClicksParams>} LogObject<bookingsUouBookingsFormClicksParams>
 */
export function bookingsUouBookingsFormClicks(params) {
    return { evid: 1052, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouSessionAddedToCartModalInteractions' event (evid: 1072)
 *
 * Event description: When the UOU has interaction with the add to cart modal
 *
 * @param {bookingsUouSessionAddedToCartModalInteractionsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - service type
 * @property {DateTime} startTime - session start_time
 * @property {GUID} visitorId - -
 * @property {string} selectedLocation - selected_location
 * @property {GUID} biToken - msid
 * @property {string} staffId - staff_id
 * @property {number} price - price
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - booking_id
 * @property {GUID} visitor_id - -
 * @property {string} price_type - label/staff/location
 * @property {string} servicePaymentOptions - what are this service payment options available
 * @property {string} paymentDetails - Which payment the uou choose - single session/ buy new pricing plan/ exisint pricing plan (in this case the field will include the pp id)
 * @property {GUID} pricingPlanId - pricing_plan_id
 * @property {number} numParticipants - num_participants
 * @property {string} selectedPaymentType - selected_payment_type
 * @property {GUID} contactId - contact_id
 * @property {string} actionName - load/go to checkout/add more sessions/close
 * @property {string} extraInfo - extra_info
 * @property {string} selectedPaymentOption - Which payment option the uou choose for a single session- online/offline
 * @property {string} currency - currency
 * @property {GUID} memberId - member_id
 * @property {string} videoType - if the session is virtual which video type - zoom/custom. null if not
 * @property {string} dynamic_price_participants_json - label, amount, num_participants
 * @property {string} serviceId - service_id
 * @property {string} referralinfo - from which page the uou came
 * @property {number} numberOfServices - number_of_services
 * @property {string} formId - booking_form_id
 * @return {LogObject<bookingsUouSessionAddedToCartModalInteractionsParams>} LogObject<bookingsUouSessionAddedToCartModalInteractionsParams>
 */
export function bookingsUouSessionAddedToCartModalInteractions(params) {
    return { evid: 1072, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouExplorePlansClick' event (evid: 1124)
 *
 * Event description: explore more plan click
 *
 * @param {bookingsUouExplorePlansClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {string} screenName - service details and more..
 * @property {string} offered_as - How is this service offered to uou (single, pricing plan, both)
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {number} price - Multiplied
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} logged - T= logged in, F= not
 * @property {boolean} is_owner - is_owner
 * @property {string} section - -
 * @property {boolean} is_membership - 1 if the service is part of membership
 * @property {boolean} bookAnotherLogged - T=http://prntscr.com/dqa17x, NULL/F=regular
 * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPendingApproval - is_pending_approval indication
 * @property {string} actionName - {navigate_to_contact_form,navigate_to_service_page,open_waiting_list_modal,open_uou_premium_modal,open_owner_premium_modal,navigate_to_specific_page,navigate_to_services_list}
 * @property {string} buttonName - the name of the button
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {string} service_id - -
 * @property {number} numberOfSlots - Number of slots presented
 * @property {boolean} isPreview - t/g
 * @return {LogObject<bookingsUouExplorePlansClickParams>} LogObject<bookingsUouExplorePlansClickParams>
 */
export function bookingsUouExplorePlansClick(params) {
    return { evid: 1124, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsV1ShutdownStrip' event (evid: 1133)
 *
 * Event description: Bookings > V1 shutdown > Strip
 *
 * @param {bookingsV1ShutdownStripParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - page name
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @return {LogObject<bookingsV1ShutdownStripParams>} LogObject<bookingsV1ShutdownStripParams>
 */
export function bookingsV1ShutdownStrip(params) {
    return { evid: 1133, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsV1ShutdownAdiPopup' event (evid: 1134)
 *
 * Event description: Bookings > V1 shutdown > ADI popup
 *
 * @param {bookingsV1ShutdownAdiPopupParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - page name
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} action - load/ switch to editor / learn more click/ close click
 * @return {LogObject<bookingsV1ShutdownAdiPopupParams>} LogObject<bookingsV1ShutdownAdiPopupParams>
 */
export function bookingsV1ShutdownAdiPopup(params) {
    return { evid: 1134, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsV1ShutdownUpdateRequestPopup' event (evid: 1135)
 *
 * Event description: Bookings > V1 shutdown > update request popup
 *
 * @param {bookingsV1ShutdownUpdateRequestPopupParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - page name
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} action - load/ update/ learn more click/ close click
 * @return {LogObject<bookingsV1ShutdownUpdateRequestPopupParams>} LogObject<bookingsV1ShutdownUpdateRequestPopupParams>
 */
export function bookingsV1ShutdownUpdateRequestPopup(params) {
    return { evid: 1135, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsV1ShutdownUpdateCompletePopup' event (evid: 1136)
 *
 * Event description: Bookings > V1 shutdown > update complete popup
 *
 * @param {bookingsV1ShutdownUpdateCompletePopupParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - page name
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @return {LogObject<bookingsV1ShutdownUpdateCompletePopupParams>} LogObject<bookingsV1ShutdownUpdateCompletePopupParams>
 */
export function bookingsV1ShutdownUpdateCompletePopup(params) {
    return { evid: 1136, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsV1ShutdownFailedToBookAppExpired' event (evid: 1139)
 *
 * Event description: Bookings > V1 shutdown > update request popup
 *
 * @param {bookingsV1ShutdownFailedToBookAppExpiredParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - page name
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} action - load/ update click/ learn more click/ close click
 * @return {LogObject<bookingsV1ShutdownFailedToBookAppExpiredParams>} LogObject<bookingsV1ShutdownFailedToBookAppExpiredParams>
 */
export function bookingsV1ShutdownFailedToBookAppExpired(params) {
    return { evid: 1139, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsSpacesAppUouBookFlowCantBookMessage' event (evid: 1140)
 *
 * Event description: currently relevant only for Spaces App. The "No services available" message accrued on the screen, due to the fail reason.
 *
 * @param {bookingsSpacesAppUouBookFlowCantBookMessageParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - page name
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {string} failReason - bookings app expired
 * @property {GUID} contactId - contact_id
 * @property {string} action - load/ contact us click
 * @return {LogObject<bookingsSpacesAppUouBookFlowCantBookMessageParams>} LogObject<bookingsSpacesAppUouBookFlowCantBookMessageParams>
 */
export function bookingsSpacesAppUouBookFlowCantBookMessage(params) {
    return { evid: 1140, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditorScript' event (evid: 1152)
 *
 * Event description: Indicate success/failed of editor script actions
 *
 * @param {bookingsEditorScriptParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} errorMessage - if action status is failed then describe the error
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isFirstInstall - indicate if the script run on first install
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} actionSucceed - indicate success/failed (true/false)
 * @property {string} actionType - describe the action in editor script
 * @property {string} origin - ex: editor/exitor-x etc..
 * @property {GUID} contactId - contact_id
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsEditorScriptParams>} LogObject<bookingsEditorScriptParams>
 */
export function bookingsEditorScript(params) {
    return { evid: 1152, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouSeeMoreDatesTimesClick' event (evid: 1162)
 *
 * Event description: See more dates & times click
 *
 * @param {bookingsUouSeeMoreDatesTimesClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget, next_available_widget}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {string} screenName - service details and more..
 * @property {string} offered_as - How is this service offered to uou (single, pricing plan, both)
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {number} price - Multiplied
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - -
 * @property {boolean} logged - T= logged in, F= not
 * @property {boolean} is_owner - is_owner
 * @property {string} section - -
 * @property {boolean} is_membership - 1 if the service is part of membership
 * @property {boolean} bookAnotherLogged - T=http://prntscr.com/dqa17x, NULL/F=regular
 * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPendingApproval - is_pending_approval indication
 * @property {string} actionName - {navigate_to_contact_form,navigate_to_service_page,open_waiting_list_modal,open_uou_premium_modal,open_owner_premium_modal,navigate_to_specific_page,navigate_to_services_list}
 * @property {string} buttonName - the name of the button
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {string} service_id - -
 * @property {boolean} isPreview - t/g
 * @return {LogObject<bookingsUouSeeMoreDatesTimesClickParams>} LogObject<bookingsUouSeeMoreDatesTimesClickParams>
 */
export function bookingsUouSeeMoreDatesTimesClick(params) {
    return { evid: 1162, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsMemberMobileAppAgendaTabInteraction' event (evid: 1167)
 *
 * Event description: A generic event of UoU usage of the tab: loaded click, swiped, etc on the calendar view and the related filters in the Agenda tab (Member App). See all values in the explicit fields:
 * element_name, actionName, type, value
 *
 * @param {bookingsMemberMobileAppAgendaTabInteractionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} element_name - the element of interaction
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - contact_id
 * @property {string} actionName - the interaction the UoU did
 * @property {string} type - the type of interaction referring to
 * @property {string} value - The value of the field of interaction
 * @property {number} applyAmount - When a UoU apply the filters selected we will report how many different filters were applied
 * @return {LogObject<bookingsMemberMobileAppAgendaTabInteractionParams>} LogObject<bookingsMemberMobileAppAgendaTabInteractionParams>
 */
export function bookingsMemberMobileAppAgendaTabInteraction(params) {
    return { evid: 1167, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouFlowSelectYouPreferencesModal' event (evid: 1174)
 *
 * Event description: Select your preferences modal load
 *
 * @param {bookingsUouFlowSelectYouPreferencesModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {string} offered_as - How is this service offered to uou (single, pricing plan, both)
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {number} price - Multiplied
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} logged - T= logged in, F= not
 * @property {boolean} is_owner - is_owner
 * @property {boolean} isCustomOption - t/f
 * @property {GUID} sequence - sequence_number
 * @property {boolean} is_membership - 1 if the service is part of membership
 * @property {string} origin - modal origin
 * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
 * @property {GUID} contactId - contact_id
 * @property {boolean} isStaffOption - t/f
 * @property {boolean} isPendingApproval - is_pending_approval indication
 * @property {string} extraInfo - extraInfo
 * @property {boolean} isLocationOption - t/f
 * @property {string} buttonName - the name of the button
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {string} service_id - -
 * @property {string} action - load/ close/ back/ location dropdown/ location chosen/ staff dropdown/ staff chosen
 * @property {boolean} isPreview - is_preview
 * @property {number} numberOfServices - number_of_services
 * @property {boolean} isMultiFlow - true/false
 * @property {string} variantType - custom / duration
 * @property {boolean} isAddOnOption - did the modal load with add-ons options
 * @return {LogObject<bookingsUouFlowSelectYouPreferencesModalParams>} LogObject<bookingsUouFlowSelectYouPreferencesModalParams>
 */
export function bookingsUouFlowSelectYouPreferencesModal(params) {
    return { evid: 1174, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouFlowClickNextOnSelectYouPreferencesModal' event (evid: 1175)
 *
 * Event description: Select your preferences modal load
 *
 * @param {bookingsUouFlowClickNextOnSelectYouPreferencesModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {string} offered_as - How is this service offered to uou (single, pricing plan, both)
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {string} staffId - staff_id
 * @property {number} price - Multiplied
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} logged - T= logged in, F= not
 * @property {GUID} location_guid - location_guid
 * @property {boolean} is_owner - is_owner
 * @property {GUID} sequence - sequence_number
 * @property {boolean} is_membership - 1 if the service is part of membership
 * @property {string} origin - modal origin
 * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPendingApproval - is_pending_approval indication
 * @property {string} buttonName - the name of the button
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {string} service_id - -
 * @property {boolean} isPreview - is_preview
 * @property {number} numberOfServices - number_of_services
 * @property {boolean} isMultiFlow - true/false
 * @return {LogObject<bookingsUouFlowClickNextOnSelectYouPreferencesModalParams>} LogObject<bookingsUouFlowClickNextOnSelectYouPreferencesModalParams>
 */
export function bookingsUouFlowClickNextOnSelectYouPreferencesModal(params) {
    return { evid: 1175, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouFlowClickSelectDateTimeOnYourAppointmentsModal' event (evid: 1176)
 *
 * Event description: Select your preferences modal load
 *
 * @param {bookingsUouFlowClickSelectDateTimeOnYourAppointmentsModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} logged - T= logged in, F= not
 * @property {boolean} is_owner - is_owner
 * @property {GUID} sequence - sequence_number
 * @property {boolean} is_membership - 1 if the service is part of membership
 * @property {string} origin - origin
 * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPendingApproval - is_pending_approval indication
 * @property {string} extraInfo - extra_info
 * @property {string} buttonName - the name of the button
 * @property {GUID} services_list - services_list
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {boolean} isPreview - is_preview
 * @property {number} numberOfServices - number_of_services
 * @property {boolean} isMultiFlow - true/false
 * @return {LogObject<bookingsUouFlowClickSelectDateTimeOnYourAppointmentsModalParams>} LogObject<bookingsUouFlowClickSelectDateTimeOnYourAppointmentsModalParams>
 */
export function bookingsUouFlowClickSelectDateTimeOnYourAppointmentsModal(params) {
    return { evid: 1176, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouFlowYourAppointmentsModal' event (evid: 1177)
 *
 * Event description: Select your preferences modal load
 *
 * @param {bookingsUouFlowYourAppointmentsModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {string} offered_as - How is this service offered to uou (single, pricing plan, both)
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {number} price - Multiplied
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} logged - T= logged in, F= not
 * @property {boolean} is_owner - is_owner
 * @property {GUID} sequence - sequenceNumber
 * @property {boolean} is_membership - 1 if the service is part of membership
 * @property {string} origin - origin
 * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPendingApproval - is_pending_approval indication
 * @property {string} extraInfo - extra_info
 * @property {string} buttonName - the name of the button
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {string} service_id - -
 * @property {string} action - load/ close/ back/ location dropdown/ location chosen/ staff dropdown/ staff chosen
 * @property {boolean} isPreview - is_preview
 * @property {number} numberOfServices - number_of_services
 * @property {boolean} isMultiFlow - true / false
 * @return {LogObject<bookingsUouFlowYourAppointmentsModalParams>} LogObject<bookingsUouFlowYourAppointmentsModalParams>
 */
export function bookingsUouFlowYourAppointmentsModal(params) {
    return { evid: 1177, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouFlowSelectAServiceModal' event (evid: 1178)
 *
 * Event description: Select your preferences modal load
 *
 * @param {bookingsUouFlowSelectAServiceModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} logged - T= logged in, F= not
 * @property {boolean} is_owner - is_owner
 * @property {GUID} sequence - sequenceNumber
 * @property {boolean} is_membership - 1 if the service is part of membership
 * @property {string} origin - origin
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPendingApproval - is_pending_approval indication
 * @property {string} buttonName - the name of the button
 * @property {string} platform - {mobile,pc}
 * @property {string} action - load/ close/ back/ location dropdown/ location chosen/ staff dropdown/ staff chosen
 * @property {boolean} isPreview - is_preview
 * @property {boolean} isMultiFlow - true / false
 * @property {number} numberOfServices - numberOfServices
 * @return {LogObject<bookingsUouFlowSelectAServiceModalParams>} LogObject<bookingsUouFlowSelectAServiceModalParams>
 */
export function bookingsUouFlowSelectAServiceModal(params) {
    return { evid: 1178, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouFlowClickContinueOnSelectAServiceModal' event (evid: 1179)
 *
 * Event description: Select your preferences modal load
 *
 * @param {bookingsUouFlowClickContinueOnSelectAServiceModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} logged - T= logged in, F= not
 * @property {boolean} is_owner - is_owner
 * @property {GUID} sequence - sequenceNumber
 * @property {boolean} is_membership - 1 if the service is part of membership
 * @property {string} origin - origin
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPendingApproval - is_pending_approval indication
 * @property {string} extraInfo - extra_info
 * @property {string} buttonName - the name of the button
 * @property {string} platform - {mobile,pc}
 * @property {string} serviceId - service_id
 * @property {boolean} isPreview - is_preview
 * @property {number} numberOfServices - number_of_services
 * @property {boolean} isMultiFlow - true / false
 * @return {LogObject<bookingsUouFlowClickContinueOnSelectAServiceModalParams>} LogObject<bookingsUouFlowClickContinueOnSelectAServiceModalParams>
 */
export function bookingsUouFlowClickContinueOnSelectAServiceModal(params) {
    return { evid: 1179, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouFlowLeaveWithoutBookingModal' event (evid: 1180)
 *
 * Event description: Select your preferences modal load
 *
 * @param {bookingsUouFlowLeaveWithoutBookingModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} logged - T= logged in, F= not
 * @property {boolean} is_owner - is_owner
 * @property {GUID} sequence - sequence
 * @property {boolean} is_membership - 1 if the service is part of membership
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPendingApproval - is_pending_approval indication
 * @property {string} buttonName - the name of the button
 * @property {string} platform - {mobile,pc}
 * @property {string} action - load/ close/ back/ location dropdown/ location chosen/ staff dropdown/ staff chosen
 * @property {boolean} isPreview - is_preview
 * @property {number} numberOfServices - number_of_services
 * @property {boolean} isMultiFlow - true / false
 * @return {LogObject<bookingsUouFlowLeaveWithoutBookingModalParams>} LogObject<bookingsUouFlowLeaveWithoutBookingModalParams>
 */
export function bookingsUouFlowLeaveWithoutBookingModal(params) {
    return { evid: 1180, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouBookingsFormClicks1185' event (evid: 1185)
 *
 * Event description: generic clicks in the service form
 *
 * @param {bookingsUouBookingsFormClicks1185Params} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} emptyCart - t/f
 * @property {string} referralInfo - -
 * @property {string} paymentOptions - list of available payment_options
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - -
 * @property {string} serviceId - service id
 * @property {string} component - component
 * @property {string} value - value
 * @property {string} action - action
 * @property {string} formId - --
 * @property {string} serviceType - appointment / class / course
 * @return {LogObject<bookingsUouBookingsFormClicks1185Params>} LogObject<bookingsUouBookingsFormClicks1185Params>
 */
export function bookingsUouBookingsFormClicks1185(params) {
    return { evid: 1185, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouBookingsFormConflictNoteShownOnPage' event (evid: 1186)
 *
 * Event description: Conflict Note Shown On page
 *
 * @param {bookingsUouBookingsFormConflictNoteShownOnPageParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} emptyCart - t/f
 * @property {string} referralInfo - -
 * @property {GUID} biToken - msid
 * @property {string} noteMessagae - note_message
 * @property {string} bookingsPlatform - -
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - -
 * @property {string} serviceId - service id
 * @property {string} formId - --
 * @return {LogObject<bookingsUouBookingsFormConflictNoteShownOnPageParams>} LogObject<bookingsUouBookingsFormConflictNoteShownOnPageParams>
 */
export function bookingsUouBookingsFormConflictNoteShownOnPage(params) {
    return { evid: 1186, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouBookingsFormPageLoaded' event (evid: 1194)
 *
 * Event description: Bookings Form page loaded
 *
 * @param {bookingsUouBookingsFormPageLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - class/course/appt
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {string} previousPage - previous_page
 * @property {GUID} contactId - contact_id
 * @property {GUID} memberId - member_id
 * @property {string} pageName - page name
 * @property {string} serviceId - service_id value
 * @return {LogObject<bookingsUouBookingsFormPageLoadedParams>} LogObject<bookingsUouBookingsFormPageLoadedParams>
 */
export function bookingsUouBookingsFormPageLoaded(params) {
    return { evid: 1194, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouSessionPagePageLoaded' event (evid: 1195)
 *
 * Event description: Session Page loaded
 *
 * @param {bookingsUouSessionPagePageLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - class/course/appt
 * @property {number} spotsLeft - number of spots left
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {string} previousPage - previous_page
 * @property {GUID} sessionId - session_id
 * @property {GUID} contactId - contact_id
 * @property {GUID} memberId - member_id
 * @property {string} pageName - page name
 * @property {string} serviceId - service_id value
 * @return {LogObject<bookingsUouSessionPagePageLoadedParams>} LogObject<bookingsUouSessionPagePageLoadedParams>
 */
export function bookingsUouSessionPagePageLoaded(params) {
    return { evid: 1195, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouSessionPageClicks' event (evid: 1197)
 *
 * Event description: generic clicks in the Session Page
 *
 * @param {bookingsUouSessionPageClicksParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - course/class/appt
 * @property {string} referralInfo - -
 * @property {string} paymentOptions - list of available payment_options
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - -
 * @property {GUID} memberId - member_id
 * @property {string} serviceId - service id
 * @property {string} action - action
 * @return {LogObject<bookingsUouSessionPageClicksParams>} LogObject<bookingsUouSessionPageClicksParams>
 */
export function bookingsUouSessionPageClicks(params) {
    return { evid: 1197, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarAppointmentModalConflictLoadForUou' event (evid: 1203)
 *
 * Event description: When a pop up modal load inside the schedule an appointment modal.
 *
 * @param {bookingsCalendarAppointmentModalConflictLoadForUouParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} name - the pop over that was loaded
 * @property {string} modalType - Create/Edit
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - contact_id
 * @return {LogObject<bookingsCalendarAppointmentModalConflictLoadForUouParams>} LogObject<bookingsCalendarAppointmentModalConflictLoadForUouParams>
 */
export function bookingsCalendarAppointmentModalConflictLoadForUou(params) {
    return { evid: 1203, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouFlowCalendarAnnotationShown' event (evid: 1204)
 *
 * Event description: Bookings > UoU Flow > Calendar > Element Loaded - Deprecated.
 *
 * @param {bookingsUouFlowCalendarAnnotationShownParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} logged - T= logged in, F= not
 * @property {boolean} is_owner - is_owner
 * @property {string} element - element
 * @property {GUID} contactId - contact_id
 * @property {string} value - value
 * @property {boolean} isPreview - is_preview
 * @property {number} numberOfServices - number_of_services
 * @return {LogObject<bookingsUouFlowCalendarAnnotationShownParams>} LogObject<bookingsUouFlowCalendarAnnotationShownParams>
 */
export function bookingsUouFlowCalendarAnnotationShown(params) {
    return { evid: 1204, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsMemberMobileAppAppointmentModalConflictLoadForUou' event (evid: 1205)
 *
 * Event description: Indications for a multi service booking id in the members app
 *
 * @param {bookingsMemberMobileAppAppointmentModalConflictLoadForUouParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} name - the pop over that was loaded
 * @property {string} modalType - Create/Edit
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - contact_id
 * @return {LogObject<bookingsMemberMobileAppAppointmentModalConflictLoadForUouParams>} LogObject<bookingsMemberMobileAppAppointmentModalConflictLoadForUouParams>
 */
export function bookingsMemberMobileAppAppointmentModalConflictLoadForUou(params) {
    return { evid: 1205, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouFlowCalendarElementLoaded' event (evid: 1209)
 *
 * Event description: Bookings > UoU Flow > Calendar > Element Loaded
 *
 * @param {bookingsUouFlowCalendarElementLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} logged - T= logged in, F= not
 * @property {boolean} is_owner - is_owner
 * @property {string} element - element
 * @property {GUID} contactId - contact_id
 * @property {string} value - value
 * @property {boolean} isPreview - is_preview
 * @property {number} numberOfServices - number_of_services
 * @return {LogObject<bookingsUouFlowCalendarElementLoadedParams>} LogObject<bookingsUouFlowCalendarElementLoadedParams>
 */
export function bookingsUouFlowCalendarElementLoaded(params) {
    return { evid: 1209, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouMemberAppsIndicationLoad' event (evid: 1214)
 *
 * Event description: When an indication is loaded on Member Apps.
 *
 * @param {bookingsUouMemberAppsIndicationLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} indicationName - The indication that was loaded on app
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - contactId
 * @property {string} pageName - page_name
 * @return {LogObject<bookingsUouMemberAppsIndicationLoadParams>} LogObject<bookingsUouMemberAppsIndicationLoadParams>
 */
export function bookingsUouMemberAppsIndicationLoad(params) {
    return { evid: 1214, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouBookingFormNextClickOnAction' event (evid: 1219)
 *
 * Event description: When the UOU click next in the booking form (valid since bookings and Ecom integration.
 *
 * @param {bookingsUouBookingFormNextClickOnActionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - type
 * @property {DateTime} startTime - session start_time
 * @property {GUID} visitorId - visitor_id
 * @property {string} selectedLocation - selected_location
 * @property {GUID} biToken - msid
 * @property {number} numberOfFields - total number of fields to fill in the form
 * @property {string} staffId - staff_id
 * @property {number} price - price
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {string} price_type - label/staff/location
 * @property {boolean} smsNotificationRequest - sms_notification_request
 * @property {string} servicePaymentOptions - what are this service payment options available
 * @property {string} paymentDetails - Which payment the uou choose - single session/ buy new pricing plan/ exisint pricing plan (in this case the field will include the pp id)
 * @property {GUID} pricingPlanId - pricing_plan_id
 * @property {boolean} smsCapability - T if sms reminder option is available
 * @property {number} numParticipants - num_participants
 * @property {number} depositAmount - deposit_amount if exists
 * @property {string} selectedPaymentType - selected_payment_type
 * @property {string} sessionId - session_id
 * @property {GUID} contactId - contact_id
 * @property {string} extraInfo - extra_info
 * @property {string} selectedPaymentOption - Which payment option the uou choose for a single session- online/offline
 * @property {string} currency - currency
 * @property {GUID} memberId - member_id
 * @property {number} numOfOptions - from jason file
 * @property {string} videoType - if the session is virtual which video type - zoom/custom. null if not
 * @property {string} dynamic_price_participants_json - label, amount, num_participants
 * @property {string} serviceId - service_id
 * @property {number} numberOfRequiredFields - total number of mandatory fields to fill in the form
 * @property {GUID} couponId - coupon_id if applied
 * @property {string} referralinfo - from which page the uou came
 * @property {string} action - choose a plan / add to cart / next
 * @property {boolean} isCouponCode - T/F if the uou applied a coupon
 * @property {number} numberOfServices - number_of_services
 * @property {string} formId - booking_form_id
 * @return {LogObject<bookingsUouBookingFormNextClickOnActionParams>} LogObject<bookingsUouBookingFormNextClickOnActionParams>
 */
export function bookingsUouBookingFormNextClickOnAction(params) {
    return { evid: 1219, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouQuickBookModalLoadActions' event (evid: 1220)
 *
 * Event description: Session Page loaded
 *
 * @param {bookingsUouQuickBookModalLoadActionsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - class/course/appt
 * @property {number} spotsLeft - number of spots left
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {string} previousPage - previous_page
 * @property {GUID} sessionId - session_id
 * @property {GUID} contactId - contact_id
 * @property {GUID} memberId - member_id
 * @property {string} pageName - page name
 * @property {string} serviceId - service_id value
 * @property {string} component - component
 * @property {string} action - action
 * @return {LogObject<bookingsUouQuickBookModalLoadActionsParams>} LogObject<bookingsUouQuickBookModalLoadActionsParams>
 */
export function bookingsUouQuickBookModalLoadActions(params) {
    return { evid: 1220, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookItClick' event (evid: 501)
 *
 * Event description: book it click - sent also from image/service name/description/learn more/read more
 *
 * @param {bookingsBookItClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {string} screenName - service details and more..
 * @property {string} offered_as - How is this service offered to uou (single, pricing plan, both)
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {number} price - Multiplied
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} logged - T= logged in, F= not
 * @property {boolean} is_owner - is_owner
 * @property {string} section - -
 * @property {boolean} is_membership - 1 if the service is part of membership
 * @property {boolean} bookAnotherLogged - T=http://prntscr.com/dqa17x, NULL/F=regular
 * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPendingApproval - is_pending_approval indication
 * @property {string} actionName - {navigate_to_contact_form,navigate_to_service_page,open_waiting_list_modal,open_uou_premium_modal,open_owner_premium_modal,navigate_to_specific_page,navigate_to_services_list}
 * @property {string} buttonName - the name of the button
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {string} service_id - -
 * @property {boolean} isPreview - is_preview
 * @property {string} isSkiEnanble - is_skip_enanble
 * @return {LogObject<bookingsBookItClickParams>} LogObject<bookingsBookItClickParams>
 */
export function bookingsBookItClick(params) {
    return { evid: 501, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsMoveDatesCalendar' event (evid: 504)
 *
 * Event description: move Dates calendar - also available from OneApp (with roles = owner, since uou don't have this reschedule flow on the app)
 *
 * @param {bookingsMoveDatesCalendarParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {string} direction - {backward,farward}
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} type - {week,month}
 * @property {string} platform - {mobile,pc}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsMoveDatesCalendarParams>} LogObject<bookingsMoveDatesCalendarParams>
 */
export function bookingsMoveDatesCalendar(params) {
    return { evid: 504, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsTodayCalendar' event (evid: 505)
 *
 * Event description: today calendar
 *
 * @param {bookingsTodayCalendarParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} type - {class\ind}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsTodayCalendarParams>} LogObject<bookingsTodayCalendarParams>
 */
export function bookingsTodayCalendar(params) {
    return { evid: 505, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsChooseTimeSlot' event (evid: 506)
 *
 * Event description: choose time slot
 *
 * @param {bookingsChooseTimeSlotParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {string} origin - optional - timetable_widget
 * @property {boolean} reschedule - T=is reschedule F= regular
 * @property {GUID} contactId - contact_id
 * @property {boolean} isWaitingList - true/false according to the indicator
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsChooseTimeSlotParams>} LogObject<bookingsChooseTimeSlotParams>
 */
export function bookingsChooseTimeSlot(params) {
    return { evid: 506, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsNextOrBookIt' event (evid: 509)
 *
 * Event description: next or book it
 *
 * @param {bookingsNextOrBookItParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - is_over_editor
 * @property {string} screenName - "session page " or "schedule tab"
 * @property {boolean} email_empty - email_empty
 * @property {string} offered_as - How is this service offered to uou (single, pricing plan, both)
 * @property {boolean} fromWaitlist - if this member is after enroll after joining waitlist
 * @property {string} mandatoryFieldsList - mandatory fields list. for referal_info='Payment_Info' only.
 * @property {GUID} biToken - msid
 * @property {number} numOfAvailableSpots - number of spots left for this session when click
 * @property {string} paymentMethod - payment_type
 * @property {number} price - price
 * @property {boolean} is_coupon - only relevant for referral "contact_info": 0- if there is an option to use a coupon but not used. 1 if coupon is applied. null otherwise
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} booked_as - relevant only after the user choose a booking option (pricing plan limited/pricing plan unlimited/single)
 * @property {GUID} visitor_id - visitor_id
 * @property {string} button_name - "book" or "book and pay"
 * @property {string} catId - cat_id
 * @property {boolean} smsNotificationRequest - TRUE if uou sms notification was requested. FALSE if not
 * @property {boolean} is_owner - is_owner
 * @property {boolean} phone_empty - phone_empty
 * @property {number} depositAmount - deposit_amount
 * @property {string} price_selection - price_selection
 * @property {boolean} is_membership - 1 if there is an option to view pricing plans for this service (part of a membership or both)
 * @property {string} selected_plan - Only relevant when there are BOTH options {membership/single session}
 * @property {boolean} reschedule - reschedule
 * @property {boolean} accept_online_bookings - T/F
 * @property {string} referal_info - date&time,contact_info,payment_info, one_app_group_session_select, one_app_appointment_session_select, one_app_date_time, one_app_agenda
 * @property {string} sessionId - -
 * @property {GUID} contactId - contact_id
 * @property {boolean} name_empty - name_empty
 * @property {string} currency - currency
 * @property {GUID} site_member_id - site_member_id - logged user
 * @property {string} type - type
 * @property {string} platform - platform
 * @property {boolean} errorOnStaff - only relevant for mobile flow on the calendar page - when having multiple staff members available and none selected
 * @property {string} serviceId - service_id
 * @property {number} numberOfRequiredFields - for referal_info='date&time' only. numbers of fields the UoU needs to fill
 * @property {boolean} isPreview - is_preview
 * @property {boolean} IsQuickBook - is_quick_book
 * @property {boolean} isSkipEnabled - is_skip_enabled
 * @return {LogObject<bookingsNextOrBookItParams>} LogObject<bookingsNextOrBookItParams>
 */
export function bookingsNextOrBookIt(params) {
    return { evid: 509, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCancelOrBack' event (evid: 510)
 *
 * Event description: cancel or back
 *
 * @param {bookingsCancelOrBackParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {string} referal_info - {date&time, contact_info,Confirmation}
 * @property {GUID} contactId - contact_id
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsCancelOrBackParams>} LogObject<bookingsCancelOrBackParams>
 */
export function bookingsCancelOrBack(params) {
    return { evid: 510, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsAnotherAppointment' event (evid: 512)
 *
 * Event description: another appointment
 *
 * @param {bookingsAnotherAppointmentParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {upcoming, history, null}
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAnotherAppointmentParams>} LogObject<bookingsAnotherAppointmentParams>
 */
export function bookingsAnotherAppointment(params) {
    return { evid: 512, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsGoogleCalendar' event (evid: 513)
 *
 * Event description: google calendar
 *
 * @param {bookingsGoogleCalendarParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} type - {ind,class}
 * @property {string} platform - {mobile,pc}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsGoogleCalendarParams>} LogObject<bookingsGoogleCalendarParams>
 */
export function bookingsGoogleCalendar(params) {
    return { evid: 513, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicesListView' event (evid: 515)
 *
 * Event description: app page is viewed on site- services page opened
 *
 * @param {bookingsServicesListViewParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} element_name - the element of interaction
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {string} pid - null = web. for oneapp = {schedule_tab, services_tab}
 * @property {boolean} isExplorePlans - t/f
 * @property {GUID} contactId - contact_id
 * @property {string} type - group\private\both
 * @property {boolean} isPreview - is_preview
 * @property {string} action - action done in the page (i.e. 'click')
 * @property {string} value - specific value in which the action was done upon (i.e. name of the category chosen)
 * @property {string} filtered_values - {CATEGORY:[ALL/<NAME>], LOCATION: [<NAME>]}
 * @return {LogObject<bookingsServicesListViewParams>} LogObject<bookingsServicesListViewParams>
 */
export function bookingsServicesListView(params) {
    return { evid: 515, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsContactInfoSaveSuccess' event (evid: 517)
 *
 * Event description: contact info save success / calendar next success
 *
 * @param {bookingsContactInfoSaveSuccessParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} timeslot - -
 * @property {string} type - -
 * @property {string} serviceType - -
 * @property {string} referralInfo - -
 * @property {boolean} is_over_editor - is_over_editor
 * @property {string} selectedLocation - location of service. Relevant to Booking Form
 * @property {string} uouPaymentOptions - What are the payment options the uou owns
 * @property {GUID} biToken - msid
 * @property {string} selectedFilters - -
 * @property {GUID} staffId - staff_id
 * @property {number} price - price
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selectedTimezone - -
 * @property {string} bookingId - booking_id = order_id in evid 16:1010
 * @property {GUID} visitor_id - visitor_id
 * @property {string} paymentType - online / offline
 * @property {string} catId - cat_id
 * @property {string} serviceProperties - -
 * @property {boolean} smsNotificationRequest - T/F
 * @property {boolean} isUoUloggedIn - T if logged in
 * @property {boolean} is_owner - is_owner
 * @property {string} servicePaymentOptions - what are this service payment options available
 * @property {string} paymentDetails - {Existing pricing plan/New Pricing Plan/ single}
 * @property {string} businessProperties - -
 * @property {boolean} smsCapability - T if sms reminder option is available
 * @property {number} numParticipants - num_participants
 * @property {number} depositAmount - deposit_amount
 * @property {string} price_selection - price_selection
 * @property {string} properties - -
 * @property {string} language - site language
 * @property {string} sessionId - --
 * @property {GUID} contactId - contact_id
 * @property {string} visibleRange - -
 * @property {string} extraInfo - extra_info
 * @property {string} currency - currency
 * @property {string} target - target page after next click
 * @property {string} selectedSlot - -
 * @property {boolean} isPremium - -
 * @property {string} pageName - -
 * @property {string} selectedRange - selected range shown
 * @property {string} platform - platform
 * @property {string} serviceId - service_id
 * @property {boolean} message_empty - message_empty
 * @property {number} numberOfRequiredFields - numbers of fields the UoU needs to fill
 * @property {boolean} isCouponCode - T if used coupon
 * @property {boolean} isPreview - is_preview
 * @property {number} numberOfServices - number_of_services
 * @property {string} formId - -
 * @return {LogObject<bookingsContactInfoSaveSuccessParams>} LogObject<bookingsContactInfoSaveSuccessParams>
 */
export function bookingsContactInfoSaveSuccess(params) {
    return { evid: 517, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentMethodSelectionNextClicked' event (evid: 518)
 *
 * Event description: UoU click on "next" in the bookings funnel - but got an error and couldn't continue (e.g., missing field in the form)
 *
 * @param {bookingsPaymentMethodSelectionNextClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} timeslot - -
 * @property {string} type - -
 * @property {string} serviceType - -
 * @property {string} referralInfo - {calendar, booking form}
 * @property {string} selectedMonth - -
 * @property {boolean} is_over_editor - -
 * @property {string} selectedDate - -
 * @property {string} errorMessage - -
 * @property {string} selectedLocation - --
 * @property {string} uouPaymentOptions - What are the payment options the uou owns
 * @property {GUID} biToken - msid
 * @property {string} selectedFilters - -
 * @property {GUID} staffId - staff_id
 * @property {string} defaultDateAtFirstLoad - -
 * @property {number} price - --
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selectedTimezone - -
 * @property {string} bookingId - -
 * @property {GUID} visitor_id - visitor_id
 * @property {string} errorReason - <error reason>
 * @property {string} serviceProperties - -
 * @property {boolean} smsNotificationRequest - TRUE if uou sms notification was requested. FALSE if not
 * @property {boolean} isUoUloggedIn - --
 * @property {boolean} is_owner - is_owner
 * @property {string} servicePaymentOptions - what are this service payment options available
 * @property {string} paymentDetails - {Existing pricing plan/New Pricing Plan/ single}
 * @property {string} businessProperties - -
 * @property {number} numParticipants - --
 * @property {string} properties - -
 * @property {string} sessionId - --
 * @property {string} userMessage - message_value
 * @property {GUID} contactId - contact_id
 * @property {string} visibleRange - -
 * @property {string} selectedSlot - -
 * @property {boolean} isPremium - -
 * @property {string} pageName - -
 * @property {string} serviceId - -
 * @property {boolean} isCouponCode - --
 * @property {string} formId - booking_form_id
 * @return {LogObject<bookingsPaymentMethodSelectionNextClickedParams>} LogObject<bookingsPaymentMethodSelectionNextClickedParams>
 */
export function bookingsPaymentMethodSelectionNextClicked(params) {
    return { evid: 518, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileLog' event (evid: 520)
 *
 * Event description: event for mobile developers -  don't delete this event! it's for them
 *
 * @param {bookingsMobileLogParams} params - The parameters for this event
 * @property {GUID} businessId - businessId
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - -
 * @property {string} message - -
 * @property {string} severity - error/warning/debug
 * @return {LogObject<bookingsMobileLogParams>} LogObject<bookingsMobileLogParams>
 */
export function bookingsMobileLog(params) {
    return { evid: 520, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCancellationPolicy' event (evid: 521)
 *
 * Event description: cancellation policy- Visitor
 *
 * @param {bookingsCancellationPolicyParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} type - {class\ind}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsCancellationPolicyParams>} LogObject<bookingsCancellationPolicyParams>
 */
export function bookingsCancellationPolicy(params) {
    return { evid: 521, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppointmentBooked' event (evid: 526)
 *
 * Event description: Appointment is booked (offline or online payment )
 *
 * @param {bookingsAppointmentBookedParams} params - The parameters for this event
 * @property {GUID} businessId - booking_id = order_id in evid 16:1010
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {boolean} courseStartedBeforeBook - T/F
 * @property {string} paymentMethod - {offline,online, paid_plan_limited, paid_plan_unlimited}
 * @property {number} price - Original Service Price, before discounts (NOT multiplied by num_participants). Multiplied by 10,000
 * @property {boolean} is_coupon - 0- if coupon not used. 1 if coupon is applied.
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bookingId - booking_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} catId - cat_id
 * @property {boolean} logged - T= logged in, F= not
 * @property {boolean} is_owner - is_owner
 * @property {number} totalPrice - Price multiplied by num_participants, after discounts. Multiplied by 10,000
 * @property {number} numParticipants - default=1
 * @property {number} depositAmount - Multiplied by 10,000
 * @property {string} price_selection - -
 * @property {boolean} is_membership - 1 or 0
 * @property {string} referal_info - for oneapp: from what screen the book was maid
 * @property {string} sessionId - --
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPendingApproval - is pending approval service
 * @property {string} currency - service booked currency
 * @property {number} originalPrice - Not relevant!
 * @property {string} type - {class\ind\course}
 * @property {string} platform - {mobile,pc}
 * @property {string} serviceId - -
 * @property {GUID} couponId - coupon_id
 * @property {string} mobileSource - -
 * @property {number} amountPaid - Price paid by user, multiplied by num_participants, after discounts. For offline = 0. Multiplied by 10,000
 * @property {boolean} isPreview - is_preview
 * @property {boolean} IsQuickBook - is_quick_book
 * @property {boolean} isSkipEnanbled - is_skip_enanbled
 * @return {LogObject<bookingsAppointmentBookedParams>} LogObject<bookingsAppointmentBookedParams>
 */
export function bookingsAppointmentBooked(params) {
    return { evid: 526, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCantBookGroupsMessage' event (evid: 527)
 *
 * Event description: The visitor received the 'Sorry, this service can’t be booked online just yet. Please get in touch' message.
 *
 * @param {bookingsCantBookGroupsMessageParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL- service list, service_page}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget phase name
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {string} failReason - array of failures
 * @property {GUID} contactId - contact_id
 * @property {string} type - service type
 * @property {string} serviceId - service_id
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsCantBookGroupsMessageParams>} LogObject<bookingsCantBookGroupsMessageParams>
 */
export function bookingsCantBookGroupsMessage(params) {
    return { evid: 527, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarDrpodownChangeStaffMemberSelection' event (evid: 529)
 *
 * Event description: sent when the UoU change the dropdown filter selection http://prntscr.com/bgni00
 *
 * @param {bookingsCalendarDrpodownChangeStaffMemberSelectionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsCalendarDrpodownChangeStaffMemberSelectionParams>} LogObject<bookingsCalendarDrpodownChangeStaffMemberSelectionParams>
 */
export function bookingsCalendarDrpodownChangeStaffMemberSelection(params) {
    return { evid: 529, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarChooseStaffMember' event (evid: 530)
 *
 * Event description: sent when the UoU choose a staff member to provide the service in the tooltip (only when all staff is selected in dropdown filter)
 *
 * @param {bookingsCalendarChooseStaffMemberParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {string} loaction - business/custom
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsCalendarChooseStaffMemberParams>} LogObject<bookingsCalendarChooseStaffMemberParams>
 */
export function bookingsCalendarChooseStaffMember(params) {
    return { evid: 530, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarChooseStaffMemberPopupOpened' event (evid: 531)
 *
 * Event description: sent when the tooltip of choose member is opened in the calendar (only services that have more than one member defined)
 *
 * @param {bookingsCalendarChooseStaffMemberPopupOpenedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} resourceList - "location_guid" or "location_text":"[staff list]"
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsCalendarChooseStaffMemberPopupOpenedParams>} LogObject<bookingsCalendarChooseStaffMemberPopupOpenedParams>
 */
export function bookingsCalendarChooseStaffMemberPopupOpened(params) {
    return { evid: 531, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsTimeZoneInfo' event (evid: 532)
 *
 * Event description: sends time zone information when calendar page is opened
 *
 * @param {bookingsTimeZoneInfoParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} visitorOffset - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {string} visitorTimeZone - -
 * @property {boolean} is_owner - is_owner
 * @property {string} ownerTimeZone - -
 * @property {GUID} contactId - contact_id
 * @property {string} ownerOffset - -
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsTimeZoneInfoParams>} LogObject<bookingsTimeZoneInfoParams>
 */
export function bookingsTimeZoneInfo(params) {
    return { evid: 532, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsChangeParticipantsQuantity' event (evid: 533)
 *
 * Event description: change participants quantity in the visitor info page  - sent only when changed previous selection
 * http://prntscr.com/bjzc2t
 *
 * @param {bookingsChangeParticipantsQuantityParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {number} numParticipants - -
 * @property {GUID} contactId - contact_id
 * @property {string} serviceId - -
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsChangeParticipantsQuantityParams>} LogObject<bookingsChangeParticipantsQuantityParams>
 */
export function bookingsChangeParticipantsQuantity(params) {
    return { evid: 533, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouQuickBookSelectDateTime' event (evid: 534)
 *
 * Event description: select date and time on the quick book widget - 4 clicks {dropdown_date / dropdown_time / select_date / select_time}
 *
 * @param {bookingsUouQuickBookSelectDateTimeParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} selectionType - dropdown_date / dropdown_time / select_date / select_time
 * @property {GUID} visitor_id - -
 * @property {boolean} is_owner - is_owner
 * @property {string} availableSlots - {all available slots}
 * @property {GUID} contactId - -
 * @property {string} selectedValue - date / time selected
 * @property {string} serviceId - -
 * @property {boolean} isPreview - -
 * @return {LogObject<bookingsUouQuickBookSelectDateTimeParams>} LogObject<bookingsUouQuickBookSelectDateTimeParams>
 */
export function bookingsUouQuickBookSelectDateTime(params) {
    return { evid: 534, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsChangeTimeZoneClicked' event (evid: 538)
 *
 * Event description: convert time zone- http://prntscr.com/c780rd
 *
 * @param {bookingsChangeTimeZoneClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} changeTo - {local,business time zone}
 * @property {string} referralInfo - {calendar,offering_page, service_page}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} timezone - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} type - {class\ind\course}
 * @property {string} serviceId - -
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsChangeTimeZoneClickedParams>} LogObject<bookingsChangeTimeZoneClickedParams>
 */
export function bookingsChangeTimeZoneClicked(params) {
    return { evid: 538, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsTimeZoneShow' event (evid: 539)
 *
 * Event description: open time zone popup  -http://prntscr.com/c781mm
 *
 * @param {bookingsTimeZoneShowParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} serviceId - -
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsTimeZoneShowParams>} LogObject<bookingsTimeZoneShowParams>
 */
export function bookingsTimeZoneShow(params) {
    return { evid: 539, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsWidgetPageLoaded' event (evid: 540)
 *
 * Event description: widget page loaded - sent once for each widget (being sent for both UoU action and user action - when drag widget to site)
 *
 * @param {bookingsWidgetPageLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} numOfServices - 0 if no services in the widget
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget version
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isEmptyState - Is there an empty state when the widget opens, for example no_availability/no_service
 * @property {GUID} visitor_id - visitor_id
 * @property {string} typeOfEmptyState - Why the empty state appeared
 * @property {boolean} is_owner - is_owner
 * @property {string} origin - {staff_widget}
 * @property {boolean} isExplorePlans - t/f
 * @property {GUID} contactId - contact_id
 * @property {string} serviceId - -
 * @property {string} layout - Layout options
 * @property {string} areTabsLocationsOrServiceCategories - service_categories, locations, null if the user didn't choose to show tabs
 * @property {number} numOfTabs - Null if no tabs
 * @return {LogObject<bookingsWidgetPageLoadedParams>} LogObject<bookingsWidgetPageLoadedParams>
 */
export function bookingsWidgetPageLoaded(params) {
    return { evid: 540, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarPageLoaded' event (evid: 541)
 *
 * Event description: calendar page loaded - sent only from the widget as a referal
 *
 * @param {bookingsCalendarPageLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} type - service type for ooi calendar only
 * @property {string} service_id - service_id value
 * @property {string} serviceType - service type for ooi calendar only
 * @property {string} referralInfo - {NULL= app settings, widget}
 * @property {boolean} is_over_editor - editor or viewer
 * @property {string} selectedDate - selected date for ooi calendar only
 * @property {string} errorMessage - empty state etc.
 * @property {GUID} biToken - msid
 * @property {string} selectedFilters - filtered_values
 * @property {string} defaultDateAtFirstLoad - for ooi calendar only
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bookingId - booking_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} serviceProperties - service_properties
 * @property {boolean} is_owner - is_owner
 * @property {string} businessProperties - business prop for ooi calendar only
 * @property {string} visibleFilters - What Filter Types are visible when the calendar loads
 * @property {GUID} contactId - contact_id
 * @property {string} visibleRange - -
 * @property {string} extraInfo - extra_info
 * @property {string} pageName - page name
 * @property {string} layout - weekly, daily_month
 * @property {string} selectedRange - selected range shown
 * @property {string} serviceId - service_id value
 * @property {boolean} isPreview - is_preview
 * @property {number} numberOfServices - number_of_services
 * @return {LogObject<bookingsCalendarPageLoadedParams>} LogObject<bookingsCalendarPageLoadedParams>
 */
export function bookingsCalendarPageLoaded(params) {
    return { evid: 541, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsLoginClick' event (evid: 542)
 *
 * Event description: click on login
 *
 * @param {bookingsLoginClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} pageName - {service_list,calendar,personal_info...}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsLoginClickParams>} LogObject<bookingsLoginClickParams>
 */
export function bookingsLoginClick(params) {
    return { evid: 542, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsReturnFromLogin' event (evid: 543)
 *
 * Event description: return from login
 *
 * @param {bookingsReturnFromLoginParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} success - success
 * @property {boolean} is_over_editor - is_over_editor
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} visitorIdAnon - the visitor_id when the visitor is anonymous- not logged in
 * @property {GUID} contactId - contact_id
 * @property {string} pageName - page_name
 * @property {boolean} firstLogin - first_login
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsReturnFromLoginParams>} LogObject<bookingsReturnFromLoginParams>
 */
export function bookingsReturnFromLogin(params) {
    return { evid: 543, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsAccountActivityUserClick' event (evid: 544)
 *
 * Event description: http://prntscr.com/d6ntxz
 *
 * @param {bookingsAccountActivityUserClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} pageName - {service_list, calendar...}
 * @property {string} service_id - NOT SENT
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAccountActivityUserClickParams>} LogObject<bookingsAccountActivityUserClickParams>
 */
export function bookingsAccountActivityUserClick(params) {
    return { evid: 544, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientVmRequestUou' event (evid: 545)
 *
 * Event description: -
 *
 * @param {bookingsClientVmRequestUouParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {string} requestedArea - requested vm {owner,settings,widget}
 * @property {GUID} contactId - contact_id
 * @return {LogObject<bookingsClientVmRequestUouParams>} LogObject<bookingsClientVmRequestUouParams>
 */
export function bookingsClientVmRequestUou(params) {
    return { evid: 545, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsLoginUserAccountAppointmentsRescheduleClick' event (evid: 546)
 *
 * Event description: on the user account (myaccount) page > appointments tab - click on reschedule appointment http://prntscr.com/dq9z2z
 *
 * @param {bookingsLoginUserAccountAppointmentsRescheduleClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} serviceid - service rescheduled
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} appointmentId - appointment rescheduled
 * @property {GUID} contactId - contact_id
 * @property {string} referralinfo - {upcoming}
 * @property {boolean} isPreview - is_preview
 * @property {string} type - INDIVIDUAL / GROUP / COURSE
 * @return {LogObject<bookingsLoginUserAccountAppointmentsRescheduleClickParams>} LogObject<bookingsLoginUserAccountAppointmentsRescheduleClickParams>
 */
export function bookingsLoginUserAccountAppointmentsRescheduleClick(params) {
    return { evid: 546, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsLoginUserAccountAppointmentsCancelClick' event (evid: 547)
 *
 * Event description: on the member area > appointments tab - click on cancel session. for the first click (http://prntscr.com/dq9zox) send confirmation=F, for the second (http://prntscr.com/dqa01c) send confirmation=T
 *
 * @param {bookingsLoginUserAccountAppointmentsCancelClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {upcoming, one_app_main_tab, one_app_upcoming_my_bookings, one_app_group_session_select}
 * @property {string} session_id - session_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} serviceid - service rescheduled
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} appointmentId - appointment rescheduled
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPendingApproval - T/F for pending approval service
 * @property {string} clickValue - possible values are: {reschedule_booking, cancel_booking, exit_modal} the exit modal should be fired it the uou click on X or gray area outside modal or a future will do this functoinallity
 * @property {string} type - Service type {appointment, class, course}
 * @property {boolean} confirmation - T= confirmation for delete F= first click
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsLoginUserAccountAppointmentsCancelClickParams>} LogObject<bookingsLoginUserAccountAppointmentsCancelClickParams>
 */
export function bookingsLoginUserAccountAppointmentsCancelClick(params) {
    return { evid: 547, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsLoginUserAccountTabNavigator' event (evid: 548)
 *
 * Event description: click on the tab navigator on the user account page - http://prntscr.com/dqa0c9
 *
 * @param {bookingsLoginUserAccountTabNavigatorParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {boolean} isEmptyState - is appointments list empty
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {string} selection - {history/ upcoming}
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsLoginUserAccountTabNavigatorParams>} LogObject<bookingsLoginUserAccountTabNavigatorParams>
 */
export function bookingsLoginUserAccountTabNavigator(params) {
    return { evid: 548, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsLoginUserAccountSeeAllServicesClick' event (evid: 549)
 *
 * Event description: click on the" see all services" button on the user account page - http://prntscr.com/dqa0rl
 *
 * @param {bookingsLoginUserAccountSeeAllServicesClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - on what tab the button was clicked -{appointments, personal info}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPreview - is_preview
 * @property {string} action - action
 * @property {GUID} bookingId - booking_id
 * @property {string} extraInfo - extra_info
 * @return {LogObject<bookingsLoginUserAccountSeeAllServicesClickParams>} LogObject<bookingsLoginUserAccountSeeAllServicesClickParams>
 */
export function bookingsLoginUserAccountSeeAllServicesClick(params) {
    return { evid: 549, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsLoginUserAccountAppointmentsRescheduleSuccess' event (evid: 551)
 *
 * Event description: on the user account (myaccount) page > appointments tab - after click on reschedule (appointment http://prntscr.com/dq9z2z) the visitor choose another date & time and clicks on next --> reschedule success
 *
 * @param {bookingsLoginUserAccountAppointmentsRescheduleSuccessParams} params - The parameters for this event
 * @property {string} serviceid - -
 * @property {GUID} businessId - business_id
 * @property {string} serviceId - -
 * @property {string} serviceType - -
 * @property {string} referralInfo - -
 * @property {string} selectedDate - -
 * @property {GUID} biToken - msid
 * @property {string} selectedFilters - -
 * @property {string} defaultDateAtFirstLoad - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selectedTimezone - -
 * @property {string} bookingId - book rescheduled
 * @property {GUID} visitor_id - visitor_id
 * @property {string} serviceProperties - -
 * @property {boolean} is_owner - is_owner
 * @property {string} businessProperties - -
 * @property {GUID} appointmentId - appointment rescheduled
 * @property {string} userMessage - -
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPremium - -
 * @property {string} pageName - -
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsLoginUserAccountAppointmentsRescheduleSuccessParams>} LogObject<bookingsLoginUserAccountAppointmentsRescheduleSuccessParams>
 */
export function bookingsLoginUserAccountAppointmentsRescheduleSuccess(params) {
    return { evid: 551, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsMemberLoginSignoutClick' event (evid: 552)
 *
 * Event description: click on signout
 *
 * @param {bookingsMemberLoginSignoutClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {string} pageName - {service_list,calendar,personal_info...}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsMemberLoginSignoutClickParams>} LogObject<bookingsMemberLoginSignoutClickParams>
 */
export function bookingsMemberLoginSignoutClick(params) {
    return { evid: 552, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentsPaymentMethodPopupChooseOffline' event (evid: 555)
 *
 * Event description: http://prntscr.com/ehwro8
 *
 * @param {bookingsPaymentsPaymentMethodPopupChooseOfflineParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - contact_id
 * @property {string} type - {class\ind}
 * @property {string} serviceId - -
 * @return {LogObject<bookingsPaymentsPaymentMethodPopupChooseOfflineParams>} LogObject<bookingsPaymentsPaymentMethodPopupChooseOfflineParams>
 */
export function bookingsPaymentsPaymentMethodPopupChooseOffline(params) {
    return { evid: 555, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicePageSeeAllServicesClick' event (evid: 556)
 *
 * Event description: course - see all schedules
 *
 * @param {bookingsServicePageSeeAllServicesClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {string} selection - {course_schedule}
 * @property {GUID} contactId - contact_id
 * @property {string} type - course.class
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsServicePageSeeAllServicesClickParams>} LogObject<bookingsServicePageSeeAllServicesClickParams>
 */
export function bookingsServicePageSeeAllServicesClick(params) {
    return { evid: 556, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsLoginFinishedRefreshAfterLogin' event (evid: 557)
 *
 * Event description: bookings >finished refresh after login
 *
 * @param {bookingsLoginFinishedRefreshAfterLoginParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - logged in visitor
 * @property {boolean} is_owner - -
 * @property {GUID} visitorIdAnon - the visitor_id when the visitor is anonymous- not logged in
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPreview - T/F
 * @return {LogObject<bookingsLoginFinishedRefreshAfterLoginParams>} LogObject<bookingsLoginFinishedRefreshAfterLoginParams>
 */
export function bookingsLoginFinishedRefreshAfterLogin(params) {
    return { evid: 557, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentsPopupForUserAsUouOpened' event (evid: 558)
 *
 * Event description: Till November-2019: Bookings > popup for user as UoU opened.
 * Similar to evid 157 on users schema  - popup opens for owner only on preview mode or live. From November-2019: Bookings > popup opened for UoU. For any popup opens to UoU.
 *
 * @param {bookingsPaymentsPopupForUserAsUouOpenedParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {boolean} is_over_editor - is_over_editor
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bookingId - booking_id
 * @property {string} referral_info - {Payments/Booking/Waitlist/Booking_Cancellation/Double_Booking_Reschedule/Double_Booking_Payment_Page/Double_Booking_Form_Page/Double_Booking_Payment_Page_Book}
 * @property {GUID} visitor_id - visitor_id
 * @property {string} sessionId - session_id
 * @property {GUID} contactId - contact_id
 * @property {string} additionalInfo - description of the modal/popup flow {waitlist_flow_download_oa}
 * @property {string} premiumStatus - {free,non_bookings_premium}
 * @property {string} type - Service type {appointment, class, course}
 * @property {GUID} serviceId - --
 * @property {boolean} isPreview - 1 if this is preview mode, 0 if live site
 * @return {LogObject<bookingsPaymentsPopupForUserAsUouOpenedParams>} LogObject<bookingsPaymentsPopupForUserAsUouOpenedParams>
 */
export function bookingsPaymentsPopupForUserAsUouOpened(params) {
    return { evid: 558, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUpgradeReferralClickUserAsUou' event (evid: 559)
 *
 * Event description: http://prntscr.com/g0jwsx
 *
 * @param {bookingsUpgradeReferralClickUserAsUouParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - {Payments, Booking}
 * @property {GUID} visitor_id - -
 * @property {boolean} is_owner - -
 * @property {GUID} contactId - contact_id
 * @property {string} premiumStatus - {free,non_bookings_premium}
 * @property {string} type - Service type {appointment, class, course}
 * @property {boolean} isPreview - 1 if this is preview mode, 0 if live site
 * @return {LogObject<bookingsUpgradeReferralClickUserAsUouParams>} LogObject<bookingsUpgradeReferralClickUserAsUouParams>
 */
export function bookingsUpgradeReferralClickUserAsUou(params) {
    return { evid: 559, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicesPageView' event (evid: 560)
 *
 * Event description: services page opened
 *
 * @param {bookingsServicesPageViewParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} sections - sections
 * @property {string} referralInfo - visitor origin to the SP. {'service title', 'learn more', 'service card deep link'}
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - -
 * @property {boolean} emptyState - T if empty state, F if not
 * @property {boolean} is_owner - is_owner
 * @property {string} message_to_user - {fully booked, not yet opened to bookings, not accepting bookings, service not available}
 * @property {string} containers - containers
 * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
 * @property {GUID} contactId - contact_id
 * @property {string} type - group\private\course
 * @property {string} platform - platform of user. example: "mobile".
 * @property {string} serviceId - service_id
 * @property {boolean} isPreview - is_preview
 * @property {GUID} siteMemberId - member_id
 * @return {LogObject<bookingsServicesPageViewParams>} LogObject<bookingsServicesPageViewParams>
 */
export function bookingsServicesPageView(params) {
    return { evid: 560, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsLoginUserAccountAppointmentsMoreDetailsServiceClick' event (evid: 561)
 *
 * Event description: on the user account (members area - my bookings) page > upcoming/history tab - click on service line https://prnt.sc/gscdqf
 *
 * @param {bookingsLoginUserAccountAppointmentsMoreDetailsServiceClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} serviceid - service more info
 * @property {GUID} visitor_id - -
 * @property {boolean} is_owner - is_owner
 * @property {string} appointmentId - appointment more info
 * @property {string} sessionId - -
 * @property {GUID} contactId - -
 * @property {boolean} isPendingApproval - T/F for pending approval service
 * @property {string} referralinfo - {upcoming, history}
 * @property {string} type - INDIVIDUAL, GROUP, COURSE
 * @property {string} actionName - Action name
 * @return {LogObject<bookingsLoginUserAccountAppointmentsMoreDetailsServiceClickParams>} LogObject<bookingsLoginUserAccountAppointmentsMoreDetailsServiceClickParams>
 */
export function bookingsLoginUserAccountAppointmentsMoreDetailsServiceClick(params) {
    return { evid: 561, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsMemberAreaListUpload' event (evid: 562)
 *
 * Event description: services list loaded (history/upcoming)
 * http://prntscr.com/gsp5qm, OneApp: https://www.screencast.com/t/PKX1IdXTOm. Sends from mobile as well!!
 *
 * @param {bookingsMemberAreaListUploadParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {number} amountSessions - the amount of sessions that in the tab
 * @property {string} bookingsPlatform
 * @property {boolean} isEmptyState - is appointments list empty
 * @property {GUID} visitor_id - -
 * @property {string} tabName - {upcoming, history}
 * @property {boolean} is_owner - is_owner
 * @property {boolean} reschedule - {F = all reschedule disables or empty state; T = at least one reschedule}
 * @property {GUID} contactId - -
 * @return {LogObject<bookingsMemberAreaListUploadParams>} LogObject<bookingsMemberAreaListUploadParams>
 */
export function bookingsMemberAreaListUpload(params) {
    return { evid: 562, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouConnectPaymentProviderOnPreviewPopup' event (evid: 564)
 *
 * Event description: popup appears - http://prntscr.com/gbmeky
 *
 * @param {bookingsUouConnectPaymentProviderOnPreviewPopupParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsUouConnectPaymentProviderOnPreviewPopupParams>} LogObject<bookingsUouConnectPaymentProviderOnPreviewPopupParams>
 */
export function bookingsUouConnectPaymentProviderOnPreviewPopup(params) {
    return { evid: 564, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsPricingPlansView' event (evid: 567)
 *
 * Event description: pricing plans page opened
 *
 * @param {bookingsPricingPlansViewParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} number_of_plans - number of defined plans
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {string} pid - page_id
 * @property {GUID} contactId - contact_id
 * @property {GUID} site_member_id - site_member_id - logged user
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsPricingPlansViewParams>} LogObject<bookingsPricingPlansViewParams>
 */
export function bookingsPricingPlansView(params) {
    return { evid: 567, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsClickOnBookAServiceButtonAfterMembershipPayment' event (evid: 568)
 *
 * Event description: bookings > click on the button after membership payment
 *
 * @param {bookingsClickOnBookAServiceButtonAfterMembershipPaymentParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {GUID} site_member_id - site_member_id - member
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsClickOnBookAServiceButtonAfterMembershipPaymentParams>} LogObject<bookingsClickOnBookAServiceButtonAfterMembershipPaymentParams>
 */
export function bookingsClickOnBookAServiceButtonAfterMembershipPayment(params) {
    return { evid: 568, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsChooseADateOnCalendar' event (evid: 570)
 *
 * Event description: choose a date on the calendar
 *
 * @param {bookingsChooseADateOnCalendarParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {boolean} reschedule - T=is reschedule F= regular
 * @property {GUID} contactId - contact_id
 * @property {GUID} site_member_id - site_member_id
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsChooseADateOnCalendarParams>} LogObject<bookingsChooseADateOnCalendarParams>
 */
export function bookingsChooseADateOnCalendar(params) {
    return { evid: 570, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsClickOnEnterPromoCode' event (evid: 571)
 *
 * Event description: Click on enter promo code from contact info page
 *
 * @param {bookingsClickOnEnterPromoCodeParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} type - {class\ind\course}
 * @property {string} serviceType - {class\ind\course}
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsClickOnEnterPromoCodeParams>} LogObject<bookingsClickOnEnterPromoCodeParams>
 */
export function bookingsClickOnEnterPromoCode(params) {
    return { evid: 571, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsApplyPromoCode' event (evid: 572)
 *
 * Event description: Apply promo code after entering it
 *
 * @param {bookingsApplyPromoCodeParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - service type {class\ind\course}
 * @property {boolean} is_over_editor - -
 * @property {string} errorMessage - --
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor id
 * @property {boolean} is_owner - is_owner
 * @property {string} couponName - coupon code
 * @property {GUID} contactId - contact_id
 * @property {string} valid_value - {ok/expired/invalid/}
 * @property {string} couponId - coupon_id
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsApplyPromoCodeParams>} LogObject<bookingsApplyPromoCodeParams>
 */
export function bookingsApplyPromoCode(params) {
    return { evid: 572, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsDeletePromoCode' event (evid: 573)
 *
 * Event description: Delete promo code - click on the garbage icon
 *
 * @param {bookingsDeletePromoCodeParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - service type {class\ind\course}
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor id
 * @property {boolean} is_owner - is_owner
 * @property {string} couponName - coupon code
 * @property {GUID} contactId - contact_id
 * @property {string} couponId - coupon_id
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsDeletePromoCodeParams>} LogObject<bookingsDeletePromoCodeParams>
 */
export function bookingsDeletePromoCode(params) {
    return { evid: 573, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppClickOnEnterPromoCodeEditCode' event (evid: 574)
 *
 * Event description: Click on enter promo code from Bookings summary page
 *
 * @param {bookingsOneAppClickOnEnterPromoCodeEditCodeParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} screenName - booking_summary / other options?
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - contact_id
 * @property {string} type - {class\ind\course}
 * @property {GUID} couponId - coupon_id - when edited
 * @return {LogObject<bookingsOneAppClickOnEnterPromoCodeEditCodeParams>} LogObject<bookingsOneAppClickOnEnterPromoCodeEditCodeParams>
 */
export function bookingsOneAppClickOnEnterPromoCodeEditCode(params) {
    return { evid: 574, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppApplyPromoCode' event (evid: 575)
 *
 * Event description: Apply promo code after entering it/click "Save"
 *
 * @param {bookingsOneAppApplyPromoCodeParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - contact_id
 * @property {string} validValue - {ok/expired/invalid}
 * @property {boolean} isEdited - 0 if the user enters the code for the first time, 1 if it is edited
 * @property {string} type - service type {class\ind\course}
 * @property {GUID} couponId - coupon_id
 * @return {LogObject<bookingsOneAppApplyPromoCodeParams>} LogObject<bookingsOneAppApplyPromoCodeParams>
 */
export function bookingsOneAppApplyPromoCode(params) {
    return { evid: 575, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppDeletePromoCode' event (evid: 576)
 *
 * Event description: Delete promo code after applying it - after clicking "save" with removing the code
 *
 * @param {bookingsOneAppDeletePromoCodeParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - contact_id
 * @property {string} type - service type {class\ind\course}
 * @property {GUID} couponId - coupon_id
 * @return {LogObject<bookingsOneAppDeletePromoCodeParams>} LogObject<bookingsOneAppDeletePromoCodeParams>
 */
export function bookingsOneAppDeletePromoCode(params) {
    return { evid: 576, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsOpenBookingsAppFromTheWidget' event (evid: 577)
 *
 * Event description: Bookings --> open Bookings app from the widget
 *
 * @param {bookingsOpenBookingsAppFromTheWidgetParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - {widget/wixCode}
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - -
 * @property {boolean} is_owner - is_owner
 * @property {string} booking_intent - {book it / more info = image and description}
 * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
 * @property {GUID} contactId - contact_id
 * @property {string} type - group\private
 * @property {GUID} service_id - service_id
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsOpenBookingsAppFromTheWidgetParams>} LogObject<bookingsOpenBookingsAppFromTheWidgetParams>
 */
export function bookingsOpenBookingsAppFromTheWidget(params) {
    return { evid: 577, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsClickLoadMoreHours' event (evid: 578)
 *
 * Event description: click in the "load more hours" option in the calendar (currently only available from mobile)
 *
 * @param {bookingsClickLoadMoreHoursParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - is_over_editor
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {boolean} reschedule - T=is reschedule F= regular
 * @property {GUID} contactId - contact_id
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsClickLoadMoreHoursParams>} LogObject<bookingsClickLoadMoreHoursParams>
 */
export function bookingsClickLoadMoreHours(params) {
    return { evid: 578, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsTimeTableNavigation' event (evid: 579)
 *
 * Event description: Navigating between different days or weeks.
 * https://prnt.sc/p0r1ux
 *
 * @param {bookingsTimeTableNavigationParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_over_editor - -
 * @property {GUID} biToken - msid
 * @property {string} widget_name - {daily_time_table, weekly_time_table}
 * @property {string} bookingsPlatform - null or new_bookings_platform for new server
 * @property {boolean} isEmptyState - true  = empty state
 * @property {GUID} visitor_id - visitor_id
 * @property {string} direction - {backward,forward}
 * @property {boolean} is_owner - is_owner
 * @property {string} navType - {day,week}
 * @property {GUID} contactId - contact_id
 * @property {string} additionalInfo - date presented
 * @property {string} type - {arrow, date}
 * @return {LogObject<bookingsTimeTableNavigationParams>} LogObject<bookingsTimeTableNavigationParams>
 */
export function bookingsTimeTableNavigation(params) {
    return { evid: 579, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsTimeTableWidgetLoad' event (evid: 580)
 *
 * Event description: calendar page loaded - sent only from the widget as a referal
 *
 * @param {bookingsTimeTableWidgetLoadParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - -
 * @property {string} widget_name - {daily_time_table, weekly_time_table}
 * @property {string} bookingsPlatform - -
 * @property {boolean} isEmptyState - true = empty state
 * @property {GUID} visitor_id - -
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - -
 * @property {string} additionalInfo - date presented
 * @return {LogObject<bookingsTimeTableWidgetLoadParams>} LogObject<bookingsTimeTableWidgetLoadParams>
 */
export function bookingsTimeTableWidgetLoad(params) {
    return { evid: 580, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsWaitlistStatus' event (evid: 581)
 *
 * Event description: waitlist status - sent once a user joins or leaves a waiting list - success
 *
 * @param {bookingsWaitlistStatusParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - {NULL= regular, widget, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, session page}
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - {mobile, pc}
 * @property {GUID} visitor_id - -
 * @property {boolean} is_owner - is_owner
 * @property {string} status - join/leave
 * @property {string} sessionId - --
 * @property {GUID} contactId - -
 * @property {string} additionalInfo - general description
 * @property {string} type - {class\ind}
 * @property {string} platform - {mobile,pc}
 * @property {string} service_id - -
 * @property {boolean} isPreview - -
 * @return {LogObject<bookingsWaitlistStatusParams>} LogObject<bookingsWaitlistStatusParams>
 */
export function bookingsWaitlistStatus(params) {
    return { evid: 581, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsDownloadClickForUou' event (evid: 582)
 *
 * Event description: For any download CTA clicked by UoU or owner only on preview mode or live.
 *
 * @param {bookingsDownloadClickForUouParams} params - The parameters for this event
 * @property {string} referral_info - -
 * @property {GUID} businessId - -
 * @property {string} type - -
 * @property {string} serviceType - -
 * @property {string} referralInfo - -
 * @property {boolean} is_over_editor - is_over_editor
 * @property {string} selectedDate - -
 * @property {GUID} biToken - -
 * @property {string} selectedFilters - -
 * @property {string} bookingsPlatform - -
 * @property {string} selectedTimezone - -
 * @property {string} bookingId - -
 * @property {GUID} visitor_id - -
 * @property {string} serviceProperties - -
 * @property {string} businessProperties - -
 * @property {GUID} contactId - -
 * @property {string} additionalInfo - CTA description {waitlist_flow_download_oa}
 * @property {string} premiumStatus - {free,non_bookings_premium}
 * @property {boolean} isPremium - -
 * @property {string} pageName - -
 * @property {string} serviceId - -
 * @property {boolean} isPreview - 1 if this is preview mode, 0 if live site
 * @return {LogObject<bookingsDownloadClickForUouParams>} LogObject<bookingsDownloadClickForUouParams>
 */
export function bookingsDownloadClickForUou(params) {
    return { evid: 582, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCoursePageViewFullScheduleClick' event (evid: 583)
 *
 * Event description: member - https://zpl.io/aR5MAez
 *
 * @param {bookingsCoursePageViewFullScheduleClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - new_bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {string} origin - member_course_page
 * @property {GUID} contactId - contact_id
 * @property {string} type - course
 * @property {string} serviceId - -
 * @return {LogObject<bookingsCoursePageViewFullScheduleClickParams>} LogObject<bookingsCoursePageViewFullScheduleClickParams>
 */
export function bookingsCoursePageViewFullScheduleClick(params) {
    return { evid: 583, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppMeTabUpcomingTap' event (evid: 584)
 *
 * Event description: member taps on an booking  in me tab, upcoming section
 *
 * @param {bookingsOneAppMeTabUpcomingTapParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - new_bookings_server
 * @property {string} bookingId - booking_id
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} waitlistEnabled - TRUE if waitlist enabled
 * @property {GUID} contactId - -
 * @property {boolean} isPendingApproval - TRUE for pending approval services
 * @property {string} type - service type {class\ind\course}
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsOneAppMeTabUpcomingTapParams>} LogObject<bookingsOneAppMeTabUpcomingTapParams>
 */
export function bookingsOneAppMeTabUpcomingTap(params) {
    return { evid: 584, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppMeTabBookAgainTap' event (evid: 585)
 *
 * Event description: member taps on an booking  in me tab, history section
 *
 * @param {bookingsOneAppMeTabBookAgainTapParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - new_bookings_server
 * @property {string} bookingId - new booking_id
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} waitlistEnabled - TRUE if waitlist enabled
 * @property {GUID} contactId - -
 * @property {boolean} isPendingApproval - TRUE for pending approval services
 * @property {string} type - service type {class\ind\course}
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsOneAppMeTabBookAgainTapParams>} LogObject<bookingsOneAppMeTabBookAgainTapParams>
 */
export function bookingsOneAppMeTabBookAgainTap(params) {
    return { evid: 585, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarDrpodownChangeLocationSelection' event (evid: 586)
 *
 * Event description: uou chose location to view from dropdown in calndar
 *
 * @param {bookingsCalendarDrpodownChangeLocationSelectionParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {boolean} is_over_editor - editor or viewer
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {GUID} visitor_id - []
 * @property {boolean} is_owner - true if is owner
 * @property {GUID} locationGuid - location id chosen
 * @property {GUID} contactId - []
 * @property {boolean} isPreview - []
 * @return {LogObject<bookingsCalendarDrpodownChangeLocationSelectionParams>} LogObject<bookingsCalendarDrpodownChangeLocationSelectionParams>
 */
export function bookingsCalendarDrpodownChangeLocationSelection(params) {
    return { evid: 586, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicePageDrpodownChangeLocationSelection' event (evid: 587)
 *
 * Event description: service page - change location in drop down
 *
 * @param {bookingsServicePageDrpodownChangeLocationSelectionParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} isOwner - []
 * @property {GUID} locationGuid - location ID
 * @property {GUID} contactId - contact_id
 * @return {LogObject<bookingsServicePageDrpodownChangeLocationSelectionParams>} LogObject<bookingsServicePageDrpodownChangeLocationSelectionParams>
 */
export function bookingsServicePageDrpodownChangeLocationSelection(params) {
    return { evid: 587, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsFitMemberAppUpcomingWidgetLoaded' event (evid: 590)
 *
 * Event description: the bookings upcoming widget was loaded
 *
 * @param {bookingsFitMemberAppUpcomingWidgetLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - contact_id
 * @return {LogObject<bookingsFitMemberAppUpcomingWidgetLoadedParams>} LogObject<bookingsFitMemberAppUpcomingWidgetLoadedParams>
 */
export function bookingsFitMemberAppUpcomingWidgetLoaded(params) {
    return { evid: 590, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsFitMemberAppUpcomingWidgetClickOnItem' event (evid: 591)
 *
 * Event description: click on item in upcoming widget
 *
 * @param {bookingsFitMemberAppUpcomingWidgetClickOnItemParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {string} section - upcoming/previous/see all
 * @property {GUID} contactId - contact_id
 * @property {string} actionName - []
 * @property {string} serviceId - service id
 * @property {string} type - INDIVIDUAL, GROUP, COURSE
 * @return {LogObject<bookingsFitMemberAppUpcomingWidgetClickOnItemParams>} LogObject<bookingsFitMemberAppUpcomingWidgetClickOnItemParams>
 */
export function bookingsFitMemberAppUpcomingWidgetClickOnItem(params) {
    return { evid: 591, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsMembersAreaMyBookingsJoinVcSession' event (evid: 592)
 *
 * Event description: sent when the member chooses to join a vc session
 *
 * @param {bookingsMembersAreaMyBookingsJoinVcSessionParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} session_id - session_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {GUID} visitor_id - -
 * @property {string} current_platform - {ZOOM/CUSTOM}
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - -
 * @return {LogObject<bookingsMembersAreaMyBookingsJoinVcSessionParams>} LogObject<bookingsMembersAreaMyBookingsJoinVcSessionParams>
 */
export function bookingsMembersAreaMyBookingsJoinVcSession(params) {
    return { evid: 592, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsMembersAreaMyBookingsJoinVcSessionModal' event (evid: 593)
 *
 * Event description: sent when the member chooses whether to join a vc meeting or copy the vc meeting link
 *
 * @param {bookingsMembersAreaMyBookingsJoinVcSessionModalParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} session_id - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {GUID} visitor_id - -
 * @property {string} current_platform - {ZOOM/CUSTOM}
 * @property {boolean} is_owner - is_owner
 * @property {string} selection - {join/copy}
 * @property {GUID} contactId - -
 * @return {LogObject<bookingsMembersAreaMyBookingsJoinVcSessionModalParams>} LogObject<bookingsMembersAreaMyBookingsJoinVcSessionModalParams>
 */
export function bookingsMembersAreaMyBookingsJoinVcSessionModal(params) {
    return { evid: 593, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarDatePickerLoad' event (evid: 594)
 *
 * Event description: calendar date picker load
 *
 * @param {bookingsCalendarDatePickerLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - service type
 * @property {string} referralInfo - service_list_widget' | 'service_details_widget' | 'members_area_reschedule' | 'members_area_book_again'
 * @property {string} selectedDate - default date
 * @property {GUID} biToken - msid
 * @property {string} selectedFilters - filtered_values
 * @property {string} defaultDateAtFirstLoad - default_date
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selectedTimezone - timezone
 * @property {string} bookingId - If reschedule then value is not null
 * @property {GUID} visitor_id - visitor_id
 * @property {string} serviceProperties - service_properties
 * @property {string} businessProperties - business_properties
 * @property {string} triggeredBy - -
 * @property {string} dateAvailability - -
 * @property {GUID} contactId - contact_id
 * @property {string} visibleRange - -
 * @property {boolean} isPremium - is_premium
 * @property {string} pageName - -
 * @property {string} layout - weekly, daily_month
 * @property {string} selectedRange - selected range shown
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsCalendarDatePickerLoadParams>} LogObject<bookingsCalendarDatePickerLoadParams>
 */
export function bookingsCalendarDatePickerLoad(params) {
    return { evid: 594, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarTimePickerLoad' event (evid: 595)
 *
 * Event description: calendar date picker load
 *
 * @param {bookingsCalendarTimePickerLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - service type
 * @property {string} referralInfo - service_list_widget' | 'service_details_widget' | 'members_area_reschedule' | 'members_area_book_again'
 * @property {string} selectedDate - -
 * @property {GUID} biToken - msid
 * @property {string} selectedFilters - filters
 * @property {string} defaultDateAtFirstLoad - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selectedTimezone - timezone
 * @property {string} bookingId - If reschedule then value is not null
 * @property {GUID} visitor_id - visitor_id
 * @property {string} serviceProperties - service properties
 * @property {string} businessProperties - business properties
 * @property {string} triggeredBy - -
 * @property {string} timeSlotsAvailability - -
 * @property {string} userMessage - -
 * @property {GUID} contactId - contact_id
 * @property {string} visibleRange - -
 * @property {boolean} isPremium - T/F
 * @property {string} pageName - -
 * @property {string} layout - weekly, daily_month (monthly)
 * @property {string} selectedRange - selected range shown
 * @property {string} serviceId - service_id
 * @property {number} numberOfSlots - # of slots presented
 * @return {LogObject<bookingsCalendarTimePickerLoadParams>} LogObject<bookingsCalendarTimePickerLoadParams>
 */
export function bookingsCalendarTimePickerLoad(params) {
    return { evid: 595, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarClick' event (evid: 596)
 *
 * Event description: calendar click UoU side
 *
 * @param {bookingsCalendarClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - {GROUP/INDIVIDUAL}
 * @property {string} referralInfo - referral
 * @property {string} selectedDate - default date
 * @property {GUID} biToken - msid
 * @property {string} selectedFilters - filters
 * @property {string} defaultDateAtFirstLoad - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selectedTimezone - timezone
 * @property {string} bookingId - If not null then reschedule
 * @property {GUID} visitor_id - visitor_id
 * @property {string} serviceProperties - service properties
 * @property {string} priceType - staff/custom
 * @property {string} businessProperties - business properties
 * @property {string} element - -
 * @property {string} properties - -
 * @property {GUID} contactId - contact_id
 * @property {string} visibleRange - -
 * @property {boolean} isPremium - T/F
 * @property {string} pageName - -
 * @property {string} layout - weekly, daily_month (monthly), 3_day(mobile)
 * @property {string} selectedRange - selected range shown
 * @property {string} serviceId - service_id
 * @property {string} component - -
 * @property {number} numberOfServices - number_of_services
 * @return {LogObject<bookingsCalendarClickParams>} LogObject<bookingsCalendarClickParams>
 */
export function bookingsCalendarClick(params) {
    return { evid: 596, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarBookingDetailsLoad' event (evid: 598)
 *
 * Event description: booking details load
 *
 * @param {bookingsCalendarBookingDetailsLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - service type
 * @property {string} referralInfo - service_list_widget' | 'service_details_widget' | 'members_area_reschedule' | 'members_area_book_again'
 * @property {boolean} isDetailsExpanded - is the details section is expanded or collapsed (currently only reported when initialize widget)
 * @property {string} selectedDate - default date
 * @property {GUID} biToken - msid
 * @property {string} selectedFilters - -
 * @property {string} defaultDateAtFirstLoad - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selectedTimezone - -
 * @property {string} bookingId - If reschedule then value is not null
 * @property {GUID} visitor_id - visitor_id
 * @property {string} errormessage - {}
 * @property {string} serviceProperties - -
 * @property {string} businessProperties - -
 * @property {string} triggeredBy - -
 * @property {string} properties - -
 * @property {string} userMessage - -
 * @property {GUID} contactId - contact_id
 * @property {string} visibleRange - -
 * @property {string} visiblePreferences - What Preferences Types are visible when the bookings details load
 * @property {DateTime} selected_month - {}
 * @property {string} selectedSlot - timeslot
 * @property {boolean} isPremium - -
 * @property {string} pageName - -
 * @property {string} layout - weekly, daily_month (monthly)
 * @property {string} selectedRange - selected range shown
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsCalendarBookingDetailsLoadParams>} LogObject<bookingsCalendarBookingDetailsLoadParams>
 */
export function bookingsCalendarBookingDetailsLoad(params) {
    return { evid: 598, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarFiltersLoad' event (evid: 599)
 *
 * Event description: filters load / refresh
 *
 * @param {bookingsCalendarFiltersLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - service type
 * @property {string} referralInfo - service_list_widget' | 'service_details_widget' | 'members_area_reschedule' | 'members_area_book_again'
 * @property {string} selectedDate - default date
 * @property {GUID} biToken - msid
 * @property {string} selectedFilters - -
 * @property {string} defaultDateAtFirstLoad - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selectedTimezone - -
 * @property {string} bookingId - If reschedule then value is not null
 * @property {GUID} visitor_id - visitor_id
 * @property {string} serviceProperties - -
 * @property {string} businessProperties - -
 * @property {string} triggeredBy - -
 * @property {GUID} contactId - contact_id
 * @property {string} visibleRange - -
 * @property {boolean} isPremium - -
 * @property {string} pageName - -
 * @property {string} layout - layout
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsCalendarFiltersLoadParams>} LogObject<bookingsCalendarFiltersLoadParams>
 */
export function bookingsCalendarFiltersLoad(params) {
    return { evid: 599, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsAllServicesTabExposure' event (evid: 602)
 *
 * Event description: sent when service list is loaded, in order to establish exposure to all services tab test
 *
 * @param {bookingsAllServicesTabExposureParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} category_toggle - is the 'All Services' category toggle on
 * @property {boolean} isMobile - is it the mobile experience
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} biToken - msid
 * @property {boolean} categoryExists - did the uou see 'all services' category
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} experimentValue - {A,B}
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - contact_id
 * @property {boolean} isPreview - -
 * @return {LogObject<bookingsAllServicesTabExposureParams>} LogObject<bookingsAllServicesTabExposureParams>
 */
export function bookingsAllServicesTabExposure(params) {
    return { evid: 602, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarErrorMessages' event (evid: 603)
 *
 * Event description: error message presented to uou
 * Example: https://zpl.io/agR5R6A
 *
 * @param {bookingsCalendarErrorMessagesParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - {class\ind}
 * @property {string} referralInfo - referral
 * @property {string} selectedDate - default date
 * @property {string} errorMessage - Fetching date availably failed\Fetching slots availably failed\Rescheduling failed\No next available date\Next available date server error\service not found\Fetch service data error
 * @property {GUID} biToken - msid
 * @property {string} selectedFilters - filters
 * @property {string} defaultDateAtFirstLoad - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selectedTimezone - timezone
 * @property {string} bookingId - If not null then reschedule
 * @property {GUID} visitor_id - visitor_id
 * @property {string} serviceProperties - service properties
 * @property {string} businessProperties - business properties
 * @property {string} properties - -
 * @property {GUID} contactId - contact_id
 * @property {string} visibleRange - -
 * @property {boolean} isPremium - T/F
 * @property {string} pageName - -
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsCalendarErrorMessagesParams>} LogObject<bookingsCalendarErrorMessagesParams>
 */
export function bookingsCalendarErrorMessages(params) {
    return { evid: 603, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsFitMemberAppPerformanceWidgetLoaded' event (evid: 604)
 *
 * Event description: performance tracker widget loaded
 *
 * @param {bookingsFitMemberAppPerformanceWidgetLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - contact_id
 * @return {LogObject<bookingsFitMemberAppPerformanceWidgetLoadedParams>} LogObject<bookingsFitMemberAppPerformanceWidgetLoadedParams>
 */
export function bookingsFitMemberAppPerformanceWidgetLoaded(params) {
    return { evid: 604, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsFitMemberAppPerformanceWidgetClickOnItem' event (evid: 605)
 *
 * Event description: click on any item in performance widget
 *
 * @param {bookingsFitMemberAppPerformanceWidgetClickOnItemParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {string} section - []
 * @property {GUID} contactId - contact_id
 * @property {string} actionName - []
 * @return {LogObject<bookingsFitMemberAppPerformanceWidgetClickOnItemParams>} LogObject<bookingsFitMemberAppPerformanceWidgetClickOnItemParams>
 */
export function bookingsFitMemberAppPerformanceWidgetClickOnItem(params) {
    return { evid: 605, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsFitMemberAppPerformanceWidgetCompleteAction' event (evid: 606)
 *
 * Event description: copleted an action in the performance tracker widget
 *
 * @param {bookingsFitMemberAppPerformanceWidgetCompleteActionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {string} section - []
 * @property {GUID} contactId - contact_id
 * @property {string} actionName - []
 * @property {string} value - value
 * @return {LogObject<bookingsFitMemberAppPerformanceWidgetCompleteActionParams>} LogObject<bookingsFitMemberAppPerformanceWidgetCompleteActionParams>
 */
export function bookingsFitMemberAppPerformanceWidgetCompleteAction(params) {
    return { evid: 606, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppIapSendMessageClick' event (evid: 607)
 *
 * Event description: Click on "Send Message" action sheet when service isn't available to purchase using the app
 *
 * @param {bookingsOneAppIapSendMessageClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} resourceId - staff / resource
 * @property {string} serviceType - {class\ind\course}
 * @property {string} onlineConferenceProvider - zoom, custom
 * @property {DateTime} startTime - session / service start time
 * @property {GUID} biToken - msid
 * @property {string} paymentMethod - {offline,online,both, paid_plan_limited, paid_plan_unlimited}
 * @property {number} price - service price multiplied by 100000
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {string} pricingPlanId - pricing plan id
 * @property {string} loaction - chosen location type
 * @property {string} scheduleId - service schedule id
 * @property {string} sessionId - session id if class
 * @property {GUID} contactId - contact_id
 * @property {string} currency - currency
 * @property {number} depositValue - if exists, multiplied by 100000
 * @property {string} serviceId - service id
 * @property {string} couponId - if exists
 * @return {LogObject<bookingsOneAppIapSendMessageClickParams>} LogObject<bookingsOneAppIapSendMessageClickParams>
 */
export function bookingsOneAppIapSendMessageClick(params) {
    return { evid: 607, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsChoosePricingMethodClick' event (evid: 613)
 *
 * Event description: When clicking on choose a pricing method button on session page on spaces
 *
 * @param {bookingsChoosePricingMethodClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {number} numOfAvailableSpots - number of spots left for this session when click
 * @property {string} bookingsPlatform - --
 * @property {GUID} visitor_id - visitor_id
 * @property {string} sessionId - -
 * @property {GUID} contactId - --
 * @property {string} type - service type
 * @property {GUID} serviceId - service id
 * @return {LogObject<bookingsChoosePricingMethodClickParams>} LogObject<bookingsChoosePricingMethodClickParams>
 */
export function bookingsChoosePricingMethodClick(params) {
    return { evid: 613, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsClickOnWaitlistAction' event (evid: 619)
 *
 * Event description: click on button to join / cancel waitlist, success event 16:581
 *
 * @param {bookingsClickOnWaitlistActionParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - {NULL= regular, widget, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, session page}
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - --
 * @property {GUID} visitor_id - -
 * @property {boolean} is_owner - is_owner
 * @property {string} status - join/leave
 * @property {string} sessionId - --
 * @property {GUID} contactId - -
 * @property {string} type - {class\ind\course}
 * @property {string} platform - {mobile,pc}
 * @property {string} service_id - -
 * @property {boolean} isPreview - -
 * @return {LogObject<bookingsClickOnWaitlistActionParams>} LogObject<bookingsClickOnWaitlistActionParams>
 */
export function bookingsClickOnWaitlistAction(params) {
    return { evid: 619, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsSessionPageContactClick' event (evid: 620)
 *
 * Event description: when price > 0 and there is a zoom link - "contact" button will appear. This event is sent when click.
 *
 * @param {bookingsSessionPageContactClickParams} params - The parameters for this event
 * @property {GUID} businessId - --
 * @property {string} referralInfo - one_app_group_session_select,one_app_course_session_select
 * @property {string} session_id - --
 * @property {GUID} biToken - --
 * @property {string} bookingsPlatform - --
 * @property {string} serviceid - service rescheduled
 * @property {GUID} visitor_id - --
 * @property {GUID} contactId - --
 * @property {string} type - Service type {appointment, class, course}
 * @return {LogObject<bookingsSessionPageContactClickParams>} LogObject<bookingsSessionPageContactClickParams>
 */
export function bookingsSessionPageContactClick(params) {
    return { evid: 620, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookFlowErrorMessages' event (evid: 621)
 *
 * Event description: error message presented to uou
 *
 * @param {bookingsBookFlowErrorMessagesParams} params - The parameters for this event
 * @property {GUID} businessId - --
 * @property {string} referralInfo - --
 * @property {string} errorMessage - Slot already taken
 * @property {GUID} biToken - --
 * @property {string} bookingsPlatform - --
 * @property {string} bookingId - If not null then reschedule
 * @property {GUID} visitor_id - --
 * @property {string} sessionId - -
 * @property {GUID} contactId - --
 * @property {string} type - {class\ind}
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsBookFlowErrorMessagesParams>} LogObject<bookingsBookFlowErrorMessagesParams>
 */
export function bookingsBookFlowErrorMessages(params) {
    return { evid: 621, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileAppsClickOnBuyMembership' event (evid: 626)
 *
 * Event description: Click on "Buy membership" (from the service page where a plan is connected)
 *
 * @param {bookingsMobileAppsClickOnBuyMembershipParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - --
 * @property {GUID} visitor_id - visitor_id
 * @property {string} eligiblePricingPlanId - Id of the chosen pricing plan
 * @property {string} sessionId - --
 * @property {GUID} contactId - contact_id
 * @property {string} selectedMethod - selected payment method {pay in person, pay online, purchase pricing plan, use pricing plan + pp id}
 * @property {string} type - service type - {individual, groups}
 * @property {string} serviceId - serviceId
 * @return {LogObject<bookingsMobileAppsClickOnBuyMembershipParams>} LogObject<bookingsMobileAppsClickOnBuyMembershipParams>
 */
export function bookingsMobileAppsClickOnBuyMembership(params) {
    return { evid: 626, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsFormLoad' event (evid: 636)
 *
 * Event description: Bookings > UoU > Bookings Form > Load.
 *
 * @param {bookingsBookingsFormLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} emptyCart - t/f
 * @property {string} referralInfo - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - -
 * @property {string} extraInfo - extraInfo
 * @property {string} serviceId - service id
 * @property {number} numberOfServices - number_of_services
 * @property {string} formId - --
 * @return {LogObject<bookingsBookingsFormLoadParams>} LogObject<bookingsBookingsFormLoadParams>
 */
export function bookingsBookingsFormLoad(params) {
    return { evid: 636, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileAppsLoadPaymentMethodScreen' event (evid: 657)
 *
 * Event description: when the screen with all the pricing method options is loaded in spaces
 *
 * @param {bookingsMobileAppsLoadPaymentMethodScreenParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - service type - {class,course,appointment}
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - --
 * @property {GUID} visitor_id - visitor_id
 * @property {string} sessionId - --
 * @property {GUID} contactId - -
 * @property {string} offeredPaymentTypes - all of the options offered to the UoU. {pay in person, pay online, purchase pricing plan, use pricing plan + pp id, eligible PP Ids}
 * @property {string} serviceId - serviceId
 * @return {LogObject<bookingsMobileAppsLoadPaymentMethodScreenParams>} LogObject<bookingsMobileAppsLoadPaymentMethodScreenParams>
 */
export function bookingsMobileAppsLoadPaymentMethodScreen(params) {
    return { evid: 657, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouBookFlowBookingFormClickNext' event (evid: 659)
 *
 * Event description: When the UOU click next in the booking form (valid since bookings and Ecom integration.)
 *
 * @param {bookingsUouBookFlowBookingFormClickNextParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - type
 * @property {DateTime} startTime - session start_time
 * @property {GUID} visitorId - visitor_id
 * @property {string} selectedLocation - selected_location
 * @property {GUID} biToken - msid
 * @property {number} numberOfFields - total number of fields to fill in the form
 * @property {string} staffId - staff_id
 * @property {number} price - price
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - booking_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} price_type - label/staff/location
 * @property {boolean} smsNotificationRequest - sms_notification_request
 * @property {string} servicePaymentOptions - what are this service payment options available
 * @property {string} paymentDetails - Which payment the uou choose - single session/ buy new pricing plan/ exisint pricing plan (in this case the field will include the pp id)
 * @property {GUID} pricingPlanId - pricing_plan_id
 * @property {boolean} smsCapability - T if sms reminder option is available
 * @property {number} numParticipants - num_participants
 * @property {number} depositAmount - deposit_amount if exists
 * @property {string} selectedPaymentType - selected_payment_type
 * @property {string} sessionId - session_id
 * @property {GUID} contactId - contact_id
 * @property {string} extraInfo - extra_info
 * @property {string} selectedPaymentOption - Which payment option the uou choose for a single session- online/offline
 * @property {string} currency - currency
 * @property {GUID} memberId - member_id
 * @property {number} numOfOptions - from jason file
 * @property {string} videoType - if the session is virtual which video type - zoom/custom. null if not
 * @property {string} dynamic_price_participants_json - label, amount, num_participants
 * @property {string} serviceId - service_id
 * @property {number} numberOfRequiredFields - total number of mandatory fields to fill in the form
 * @property {GUID} couponId - coupon_id if applied
 * @property {string} referralinfo - from which page the uou came
 * @property {string} action - choose a plan / add to cart / next
 * @property {boolean} isCouponCode - T/F if the uou applied a coupon
 * @property {number} numberOfServices - number_of_services
 * @property {string} formId - booking_form_id
 * @return {LogObject<bookingsUouBookFlowBookingFormClickNextParams>} LogObject<bookingsUouBookFlowBookingFormClickNextParams>
 */
export function bookingsUouBookFlowBookingFormClickNext(params) {
    return { evid: 659, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsUouBookFlowBookingFormClickNextFailure' event (evid: 665)
 *
 * Event description: When the UOU click next in the booking form (valid since bookings and Ecom integration.)
 *
 * @param {bookingsUouBookFlowBookingFormClickNextFailureParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - type
 * @property {DateTime} startTime - start_time
 * @property {GUID} visitorId - visitor_id
 * @property {string} selectedLocation - selected_location
 * @property {GUID} biToken - msid
 * @property {number} numberOfFields - total number of fields to fill in the form
 * @property {string} staffId - staff_id
 * @property {number} price - price
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - booking_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} errorReason - error_reason
 * @property {boolean} smsNotificationRequest - sms_notification_request
 * @property {string} servicePaymentOptions - what are this service payment options available
 * @property {string} paymentDetails - Which payment the uou choose - single session/ buy new pricing plan/ exisint pricing plan (in this case the field will include the pp id)
 * @property {GUID} pricingPlanId - pricing_plan_id
 * @property {boolean} smsCapability - T if sms reminder option is available
 * @property {number} numParticipants - num_participants
 * @property {number} depositAmount - deposit_amount if exists
 * @property {string} sessionId - session_id
 * @property {GUID} contactId - contact_id
 * @property {string} selectedPaymentOption - Which payment option the uou choose to pay when pay for a single session
 * @property {string} currency - currency
 * @property {GUID} memberId - memberid
 * @property {string} videoType - if the session is virtual which video type - zoom/custom. null if not
 * @property {string} serviceId - service_id
 * @property {number} numberOfRequiredFields - total number of mandatory fields to fill in the form
 * @property {GUID} couponId - coupon_id if applied
 * @property {string} referralinfo - from which page the uou came
 * @property {boolean} isCouponCode - T/F if the uou applied a coupon
 * @property {string} formId - booking_form_id
 * @return {LogObject<bookingsUouBookFlowBookingFormClickNextFailureParams>} LogObject<bookingsUouBookFlowBookingFormClickNextFailureParams>
 */
export function bookingsUouBookFlowBookingFormClickNextFailure(params) {
    return { evid: 665, src: 16, endpoint: 'wixboost-ugc', params: params };
}
/**
 * A function to create a log object for the 'bookingsTestsExposureEvent' event (evid: 666)
 *
 * Event description: test exposure event for bookings tests
 *
 * @param {bookingsTestsExposureEventParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} testName - test name
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} biToken - -
 * @property {string} widget_name - widget_name
 * @property {GUID} uuid - uuid if it's user test, else null
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} contactId - contact_id
 * @property {boolean} is_eligible - true/false
 * @property {string} postreg_category - postreg_category
 * @property {string} triggerName - exposure point name
 * @return {LogObject<bookingsTestsExposureEventParams>} LogObject<bookingsTestsExposureEventParams>
 */
export function bookingsTestsExposureEvent(params) {
    return { evid: 666, src: 16, endpoint: 'wixboost-ugc', params: params };
}
//# sourceMappingURL=index.js.map